//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

export interface IHelpLinkClient {
    addOrUpdateHelpLink(helpLinks: AddOrUpdateHelpLinkRequest): Observable<AddOrUpdateHelpLinkResponse>;
    getHelpLinks(): Observable<GetHelpLinksResponse>;
    deleteHelpLink(request: DeleteHelpLinkRequest): Observable<DeleteHelpLinkResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class HelpLinkClient implements IHelpLinkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    addOrUpdateHelpLink(helpLinks: AddOrUpdateHelpLinkRequest): Observable<AddOrUpdateHelpLinkResponse> {
        let url_ = this.baseUrl + "/v1/HelpLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(helpLinks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateHelpLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateHelpLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddOrUpdateHelpLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddOrUpdateHelpLinkResponse>;
        }));
    }

    protected processAddOrUpdateHelpLink(response: HttpResponseBase): Observable<AddOrUpdateHelpLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOrUpdateHelpLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelpLinks(): Observable<GetHelpLinksResponse> {
        let url_ = this.baseUrl + "/v1/HelpLink/GetHelpLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelpLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelpLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHelpLinksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHelpLinksResponse>;
        }));
    }

    protected processGetHelpLinks(response: HttpResponseBase): Observable<GetHelpLinksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHelpLinksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteHelpLink(request: DeleteHelpLinkRequest): Observable<DeleteHelpLinkResponse> {
        let url_ = this.baseUrl + "/v1/HelpLink/DeleteHelpLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHelpLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHelpLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteHelpLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteHelpLinkResponse>;
        }));
    }

    protected processDeleteHelpLink(response: HttpResponseBase): Observable<DeleteHelpLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteHelpLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInKindClient {
    getInKinds(employeeId?: string | null | undefined): Observable<GetInKindsResponse>;
    getInKindById(id?: number | undefined): Observable<GetInKindByIdResponse>;
    createInKind(inKind: CreateInKindRequest): Observable<CreateInKindResponse>;
    updateInKind(request: UpdateInKindRequest): Observable<UpdateInKindResponse>;
    deleteInKind(id?: number | undefined): Observable<DeleteInKindResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class InKindClient implements IInKindClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getInKinds(employeeId?: string | null | undefined): Observable<GetInKindsResponse> {
        let url_ = this.baseUrl + "/v1/InKind/GetInKinds?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInKindsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInKindsResponse>;
        }));
    }

    protected processGetInKinds(response: HttpResponseBase): Observable<GetInKindsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInKindsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInKindById(id?: number | undefined): Observable<GetInKindByIdResponse> {
        let url_ = this.baseUrl + "/v1/InKind/GetInKindById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInKindById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInKindById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInKindByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInKindByIdResponse>;
        }));
    }

    protected processGetInKindById(response: HttpResponseBase): Observable<GetInKindByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInKindByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInKind(inKind: CreateInKindRequest): Observable<CreateInKindResponse> {
        let url_ = this.baseUrl + "/v1/InKind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inKind);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateInKindResponse>;
        }));
    }

    protected processCreateInKind(response: HttpResponseBase): Observable<CreateInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInKind(request: UpdateInKindRequest): Observable<UpdateInKindResponse> {
        let url_ = this.baseUrl + "/v1/InKind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateInKindResponse>;
        }));
    }

    protected processUpdateInKind(response: HttpResponseBase): Observable<UpdateInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInKind(id?: number | undefined): Observable<DeleteInKindResponse> {
        let url_ = this.baseUrl + "/v1/InKind/DeleteInKind?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteInKindResponse>;
        }));
    }

    protected processDeleteInKind(response: HttpResponseBase): Observable<DeleteInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrgInfoClient {
    getCostCenterOrgInfo(): Observable<OrgInfoVM[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OrgInfoClient implements IOrgInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getCostCenterOrgInfo(): Observable<OrgInfoVM[]> {
        let url_ = this.baseUrl + "/v1/OrgInfo/GetCostCenterOrgInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenterOrgInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenterOrgInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgInfoVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgInfoVM[]>;
        }));
    }

    protected processGetCostCenterOrgInfo(response: HttpResponseBase): Observable<OrgInfoVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgInfoVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectMasterClient {
    projectMaster(reportPersonId?: number | null | undefined): Observable<ProjectMasterListItem[]>;
    getProjectById(id?: number | undefined): Observable<GetProjectByIdResponse>;
    updateProject(request: UpdateProjectRequest): Observable<UpdateProjectResponse>;
    addProject(request: CreateProjectRequest): Observable<CreateProjectResponse>;
    getRMSProjectNumbers(): Observable<GetRMSProjectNumbersResponse>;
    getProjectAndSubProjectsByRMSNum(rmsNum?: string | null | undefined, isRMS?: boolean | undefined): Observable<GetProjectAndSubProjectsByRMSNumResponse>;
    refreshSubProjects(request: RefreshSubProjectsRequest): Observable<RefreshSubProjectsResponse>;
    deleteProject(id?: number | undefined): Observable<DeleteProjectResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectMasterClient implements IProjectMasterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    projectMaster(reportPersonId?: number | null | undefined): Observable<ProjectMasterListItem[]> {
        let url_ = this.baseUrl + "/v1/ProjectMaster/ProjectMaster?";
        if (reportPersonId !== undefined && reportPersonId !== null)
            url_ += "reportPersonId=" + encodeURIComponent("" + reportPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMasterListItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMasterListItem[]>;
        }));
    }

    protected processProjectMaster(response: HttpResponseBase): Observable<ProjectMasterListItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectMasterListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectById(id?: number | undefined): Observable<GetProjectByIdResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectByIdResponse>;
        }));
    }

    protected processGetProjectById(response: HttpResponseBase): Observable<GetProjectByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProject(request: UpdateProjectRequest): Observable<UpdateProjectResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProjectResponse>;
        }));
    }

    protected processUpdateProject(response: HttpResponseBase): Observable<UpdateProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProject(request: CreateProjectRequest): Observable<CreateProjectResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProjectResponse>;
        }));
    }

    protected processAddProject(response: HttpResponseBase): Observable<CreateProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRMSProjectNumbers(): Observable<GetRMSProjectNumbersResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster/GetRMSProjectNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRMSProjectNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRMSProjectNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRMSProjectNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRMSProjectNumbersResponse>;
        }));
    }

    protected processGetRMSProjectNumbers(response: HttpResponseBase): Observable<GetRMSProjectNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRMSProjectNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectAndSubProjectsByRMSNum(rmsNum?: string | null | undefined, isRMS?: boolean | undefined): Observable<GetProjectAndSubProjectsByRMSNumResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster/GetProjectAndSubProjectsByRMSNum?";
        if (rmsNum !== undefined && rmsNum !== null)
            url_ += "rmsNum=" + encodeURIComponent("" + rmsNum) + "&";
        if (isRMS === null)
            throw new Error("The parameter 'isRMS' cannot be null.");
        else if (isRMS !== undefined)
            url_ += "isRMS=" + encodeURIComponent("" + isRMS) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAndSubProjectsByRMSNum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAndSubProjectsByRMSNum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectAndSubProjectsByRMSNumResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectAndSubProjectsByRMSNumResponse>;
        }));
    }

    protected processGetProjectAndSubProjectsByRMSNum(response: HttpResponseBase): Observable<GetProjectAndSubProjectsByRMSNumResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectAndSubProjectsByRMSNumResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshSubProjects(request: RefreshSubProjectsRequest): Observable<RefreshSubProjectsResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster/RefreshSubProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSubProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSubProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshSubProjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshSubProjectsResponse>;
        }));
    }

    protected processRefreshSubProjects(response: HttpResponseBase): Observable<RefreshSubProjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshSubProjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProject(id?: number | undefined): Observable<DeleteProjectResponse> {
        let url_ = this.baseUrl + "/v1/ProjectMaster/DeleteProject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteProjectResponse>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<DeleteProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRecentActivityClient {
    addRecentActivity(recentActivity: AddRecentActivityRequest): Observable<AddRecentActivityResponse>;
    getRecentActivity(userId?: string | null | undefined): Observable<GetRecentActivitiesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RecentActivityClient implements IRecentActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    addRecentActivity(recentActivity: AddRecentActivityRequest): Observable<AddRecentActivityResponse> {
        let url_ = this.baseUrl + "/v1/RecentActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recentActivity);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRecentActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRecentActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddRecentActivityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddRecentActivityResponse>;
        }));
    }

    protected processAddRecentActivity(response: HttpResponseBase): Observable<AddRecentActivityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddRecentActivityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecentActivity(userId?: string | null | undefined): Observable<GetRecentActivitiesResponse> {
        let url_ = this.baseUrl + "/v1/RecentActivity/GetRecentActivity?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentActivitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentActivitiesResponse>;
        }));
    }

    protected processGetRecentActivity(response: HttpResponseBase): Observable<GetRecentActivitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentActivitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRecordHistoryClient {
    getRecordHistory(recordId?: number | undefined, recordType?: string | null | undefined): Observable<GetRecordHistoryResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RecordHistoryClient implements IRecordHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getRecordHistory(recordId?: number | undefined, recordType?: string | null | undefined): Observable<GetRecordHistoryResponse> {
        let url_ = this.baseUrl + "/v1/RecordHistory/GetRecordHistory?";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        if (recordType !== undefined && recordType !== null)
            url_ += "recordType=" + encodeURIComponent("" + recordType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecordHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecordHistoryResponse>;
        }));
    }

    protected processGetRecordHistory(response: HttpResponseBase): Observable<GetRecordHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecordHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportClient {
    createReportByPerson(request: CreateReportByPersonRequest): Observable<CreateReportByPersonResponse>;
    copyReportByReportId(request: CopyReportByReportIdRequest): Observable<CopyReportByReportIdResponse>;
    getReportsByPersonId(personId?: number | undefined): Observable<GetReportsByPersonIdResponse>;
    getReportsOutForReview(): Observable<GetReportsOutForReviewResponse>;
    getReportsByEmployeeId(employeeId?: string | null | undefined): Observable<GetReportsByPersonIdResponse>;
    getReportHeadersByPersonId(personId?: number | undefined): Observable<GetReportHeadersByPersonIdResponse>;
    getReportById(id?: number | undefined): Observable<GetReportByIdResponse>;
    updateReport(request: UpdateReportRequest): Observable<UpdateReportResponse>;
    deleteReport(id?: number | undefined): Observable<DeleteReportResponse>;
    getReportPerson(reportPersonId?: number | undefined): Observable<GetReportPersonByIdResponse>;
    exportPdf(request: ExportReportRequest): Observable<FileResponse>;
    exportCommonFormPDF(request: ExportCommonFormReportRequest): Observable<FileResponse>;
    exportDocx(request: ExportReportDocxRequest): Observable<FileResponse>;
    exportCommonFormDocx(request: ExportCommonFormReportDocxRequest): Observable<FileResponse>;
    exportXml(request: ExportXmlRequest): Observable<FileResponse>;
    addMasterProjectsToReport(id: number, masterProjectIds: number[]): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportClient implements IReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    createReportByPerson(request: CreateReportByPersonRequest): Observable<CreateReportByPersonResponse> {
        let url_ = this.baseUrl + "/v1/Report/CreateReportByPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportByPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportByPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateReportByPersonResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateReportByPersonResponse>;
        }));
    }

    protected processCreateReportByPerson(response: HttpResponseBase): Observable<CreateReportByPersonResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReportByPersonResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyReportByReportId(request: CopyReportByReportIdRequest): Observable<CopyReportByReportIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/CopyReportByReportId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyReportByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyReportByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CopyReportByReportIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CopyReportByReportIdResponse>;
        }));
    }

    protected processCopyReportByReportId(response: HttpResponseBase): Observable<CopyReportByReportIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CopyReportByReportIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportsByPersonId(personId?: number | undefined): Observable<GetReportsByPersonIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportsByPersonId?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportsByPersonIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportsByPersonIdResponse>;
        }));
    }

    protected processGetReportsByPersonId(response: HttpResponseBase): Observable<GetReportsByPersonIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportsByPersonIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportsOutForReview(): Observable<GetReportsOutForReviewResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportsOutForReview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsOutForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsOutForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportsOutForReviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportsOutForReviewResponse>;
        }));
    }

    protected processGetReportsOutForReview(response: HttpResponseBase): Observable<GetReportsOutForReviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportsOutForReviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportsByEmployeeId(employeeId?: string | null | undefined): Observable<GetReportsByPersonIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportsByEmployeeId?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportsByPersonIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportsByPersonIdResponse>;
        }));
    }

    protected processGetReportsByEmployeeId(response: HttpResponseBase): Observable<GetReportsByPersonIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportsByPersonIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportHeadersByPersonId(personId?: number | undefined): Observable<GetReportHeadersByPersonIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportHeadersByPersonId?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportHeadersByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportHeadersByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportHeadersByPersonIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportHeadersByPersonIdResponse>;
        }));
    }

    protected processGetReportHeadersByPersonId(response: HttpResponseBase): Observable<GetReportHeadersByPersonIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportHeadersByPersonIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportById(id?: number | undefined): Observable<GetReportByIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportByIdResponse>;
        }));
    }

    protected processGetReportById(response: HttpResponseBase): Observable<GetReportByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReport(request: UpdateReportRequest): Observable<UpdateReportResponse> {
        let url_ = this.baseUrl + "/v1/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReportResponse>;
        }));
    }

    protected processUpdateReport(response: HttpResponseBase): Observable<UpdateReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReport(id?: number | undefined): Observable<DeleteReportResponse> {
        let url_ = this.baseUrl + "/v1/Report/DeleteReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportResponse>;
        }));
    }

    protected processDeleteReport(response: HttpResponseBase): Observable<DeleteReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportPerson(reportPersonId?: number | undefined): Observable<GetReportPersonByIdResponse> {
        let url_ = this.baseUrl + "/v1/Report/GetReportPerson?";
        if (reportPersonId === null)
            throw new Error("The parameter 'reportPersonId' cannot be null.");
        else if (reportPersonId !== undefined)
            url_ += "reportPersonId=" + encodeURIComponent("" + reportPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportPersonByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportPersonByIdResponse>;
        }));
    }

    protected processGetReportPerson(response: HttpResponseBase): Observable<GetReportPersonByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportPersonByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPdf(request: ExportReportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Report/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCommonFormPDF(request: ExportCommonFormReportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Report/commonForm/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommonFormPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommonFormPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCommonFormPDF(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportDocx(request: ExportReportDocxRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Report/docx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDocx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDocx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportDocx(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCommonFormDocx(request: ExportCommonFormReportDocxRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Report/commonForm/docx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommonFormDocx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommonFormDocx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCommonFormDocx(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportXml(request: ExportXmlRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/Report/xml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportXml(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMasterProjectsToReport(id: number, masterProjectIds: number[]): Observable<string> {
        let url_ = this.baseUrl + "/v1/Report/addMasterProjects/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(masterProjectIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMasterProjectsToReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMasterProjectsToReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddMasterProjectsToReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportInKindClient {
    getReportInKinds(reportId?: number | undefined): Observable<GetReportInKindsResponse>;
    createReportInKind(inKind: CreateReportInKindRequest): Observable<CreateReportInKindResponse>;
    updateReportInKind(request: UpdateReportInKindRequest): Observable<UpdateReportInKindResponse>;
    refreshInKinds(reportInKindIds: number[]): Observable<string[]>;
    saveToMasterInKindList(request: SaveToMasterInKindListRequest): Observable<SaveToMasterInKindListResponse>;
    saveArrToMasterInKindList(request: SaveArrToMasterInKindListRequest): Observable<SaveArrToMasterInKindListResponse>;
    deleteReportInKind(id?: number | undefined): Observable<DeleteReportInKindResponse>;
    deleteReportInKindArr(reportInkindsToDelete: ReportInKindVM[]): Observable<DeleteReportInKindArrResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportInKindClient implements IReportInKindClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getReportInKinds(reportId?: number | undefined): Observable<GetReportInKindsResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind/GetReportInKinds?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportInKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportInKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportInKindsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportInKindsResponse>;
        }));
    }

    protected processGetReportInKinds(response: HttpResponseBase): Observable<GetReportInKindsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportInKindsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createReportInKind(inKind: CreateReportInKindRequest): Observable<CreateReportInKindResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inKind);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateReportInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateReportInKindResponse>;
        }));
    }

    protected processCreateReportInKind(response: HttpResponseBase): Observable<CreateReportInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReportInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReportInKind(request: UpdateReportInKindRequest): Observable<UpdateReportInKindResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReportInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReportInKindResponse>;
        }));
    }

    protected processUpdateReportInKind(response: HttpResponseBase): Observable<UpdateReportInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateReportInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshInKinds(reportInKindIds: number[]): Observable<string[]> {
        let url_ = this.baseUrl + "/v1/ReportInKind/RefreshInKinds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportInKindIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshInKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshInKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processRefreshInKinds(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveToMasterInKindList(request: SaveToMasterInKindListRequest): Observable<SaveToMasterInKindListResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind/SaveToMasterInKindList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveToMasterInKindList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveToMasterInKindList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveToMasterInKindListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveToMasterInKindListResponse>;
        }));
    }

    protected processSaveToMasterInKindList(response: HttpResponseBase): Observable<SaveToMasterInKindListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveToMasterInKindListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveArrToMasterInKindList(request: SaveArrToMasterInKindListRequest): Observable<SaveArrToMasterInKindListResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind/SaveArrToMasterInKindList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveArrToMasterInKindList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveArrToMasterInKindList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveArrToMasterInKindListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveArrToMasterInKindListResponse>;
        }));
    }

    protected processSaveArrToMasterInKindList(response: HttpResponseBase): Observable<SaveArrToMasterInKindListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveArrToMasterInKindListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReportInKind(id?: number | undefined): Observable<DeleteReportInKindResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind/DeleteReportInKind?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportInKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportInKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportInKindResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportInKindResponse>;
        }));
    }

    protected processDeleteReportInKind(response: HttpResponseBase): Observable<DeleteReportInKindResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportInKindResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReportInKindArr(reportInkindsToDelete: ReportInKindVM[]): Observable<DeleteReportInKindArrResponse> {
        let url_ = this.baseUrl + "/v1/ReportInKind/DeleteReportInKindArr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportInkindsToDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportInKindArr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportInKindArr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportInKindArrResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportInKindArrResponse>;
        }));
    }

    protected processDeleteReportInKindArr(response: HttpResponseBase): Observable<DeleteReportInKindArrResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportInKindArrResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportProjectClient {
    getReportProjects(reportId?: number | undefined): Observable<GetReportProjectsResponse>;
    getActiveProjectsTotalPercent(reportId?: number | undefined): Observable<GetActiveProjectsTotalPercentResponse>;
    getProjectByRMSProjectNum(rmsNum?: string | null | undefined): Observable<GetReportProjectByRMSProjectNumResponse>;
    getReportProjectById(id?: number | undefined): Observable<GetReportProjectByIdResponse>;
    createReportProject(reportProject: CreateReportProjectRequest): Observable<CreateReportProjectResponse>;
    updateReportProject(request: UpdateReportProjectRequest): Observable<UpdateReportProjectResponse>;
    deleteReportProject(id?: number | undefined): Observable<DeleteReportProjectResponse>;
    refreshFromMasterList(reportProjects: RefreshProject[]): Observable<string[]>;
    refreshFromRms(reportProjects: RefreshProject[]): Observable<number>;
    deleteReportProjectArr(reportProjectsToDelete: ReportProjectVM[]): Observable<DeleteReportProjectArrResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportProjectClient implements IReportProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getReportProjects(reportId?: number | undefined): Observable<GetReportProjectsResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/GetReportProjects?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportProjectsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportProjectsResponse>;
        }));
    }

    protected processGetReportProjects(response: HttpResponseBase): Observable<GetReportProjectsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportProjectsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveProjectsTotalPercent(reportId?: number | undefined): Observable<GetActiveProjectsTotalPercentResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/GetActiveProjectsTotalPercent?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveProjectsTotalPercent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveProjectsTotalPercent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActiveProjectsTotalPercentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActiveProjectsTotalPercentResponse>;
        }));
    }

    protected processGetActiveProjectsTotalPercent(response: HttpResponseBase): Observable<GetActiveProjectsTotalPercentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActiveProjectsTotalPercentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectByRMSProjectNum(rmsNum?: string | null | undefined): Observable<GetReportProjectByRMSProjectNumResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/GetProjectByRMSProjectNum?";
        if (rmsNum !== undefined && rmsNum !== null)
            url_ += "rmsNum=" + encodeURIComponent("" + rmsNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectByRMSProjectNum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectByRMSProjectNum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportProjectByRMSProjectNumResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportProjectByRMSProjectNumResponse>;
        }));
    }

    protected processGetProjectByRMSProjectNum(response: HttpResponseBase): Observable<GetReportProjectByRMSProjectNumResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportProjectByRMSProjectNumResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportProjectById(id?: number | undefined): Observable<GetReportProjectByIdResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/GetReportProjectById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportProjectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportProjectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportProjectByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportProjectByIdResponse>;
        }));
    }

    protected processGetReportProjectById(response: HttpResponseBase): Observable<GetReportProjectByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportProjectByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createReportProject(reportProject: CreateReportProjectRequest): Observable<CreateReportProjectResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportProject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateReportProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateReportProjectResponse>;
        }));
    }

    protected processCreateReportProject(response: HttpResponseBase): Observable<CreateReportProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReportProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReportProject(request: UpdateReportProjectRequest): Observable<UpdateReportProjectResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReportProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReportProjectResponse>;
        }));
    }

    protected processUpdateReportProject(response: HttpResponseBase): Observable<UpdateReportProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateReportProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReportProject(id?: number | undefined): Observable<DeleteReportProjectResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/DeleteReportProject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportProjectResponse>;
        }));
    }

    protected processDeleteReportProject(response: HttpResponseBase): Observable<DeleteReportProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshFromMasterList(reportProjects: RefreshProject[]): Observable<string[]> {
        let url_ = this.baseUrl + "/v1/ReportProject/RefreshFromMasterList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportProjects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshFromMasterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshFromMasterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processRefreshFromMasterList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshFromRms(reportProjects: RefreshProject[]): Observable<number> {
        let url_ = this.baseUrl + "/v1/ReportProject/RefreshFromRms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportProjects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshFromRms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshFromRms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRefreshFromRms(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReportProjectArr(reportProjectsToDelete: ReportProjectVM[]): Observable<DeleteReportProjectArrResponse> {
        let url_ = this.baseUrl + "/v1/ReportProject/DeleteReportProjectArr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportProjectsToDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportProjectArr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportProjectArr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportProjectArrResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportProjectArrResponse>;
        }));
    }

    protected processDeleteReportProjectArr(response: HttpResponseBase): Observable<DeleteReportProjectArrResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportProjectArrResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportTemplateClient {
    createReportTemplate(request: CreateReportTemplateRequest): Observable<CreateReportTemplateResponse>;
    getReportTemplateByType(type?: string | null | undefined): Observable<GetReportTemplateResponse>;
    getAllReportTemplates(report?: GetAllReportTemplatesRequest | null | undefined): Observable<GetAllReportTemplatesResponse>;
    updateReportTemplate(request: UpdateReportTemplateRequest): Observable<UpdateReportTemplateResponse>;
    deleteReportTemplate(id?: number | undefined): Observable<DeleteReportTemplateResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportTemplateClient implements IReportTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    createReportTemplate(request: CreateReportTemplateRequest): Observable<CreateReportTemplateResponse> {
        let url_ = this.baseUrl + "/v1/ReportTemplate/CreateReportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateReportTemplateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateReportTemplateResponse>;
        }));
    }

    protected processCreateReportTemplate(response: HttpResponseBase): Observable<CreateReportTemplateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReportTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportTemplateByType(type?: string | null | undefined): Observable<GetReportTemplateResponse> {
        let url_ = this.baseUrl + "/v1/ReportTemplate/GetReportTemplateByType?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTemplateByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTemplateByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportTemplateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportTemplateResponse>;
        }));
    }

    protected processGetReportTemplateByType(response: HttpResponseBase): Observable<GetReportTemplateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllReportTemplates(report?: GetAllReportTemplatesRequest | null | undefined): Observable<GetAllReportTemplatesResponse> {
        let url_ = this.baseUrl + "/v1/ReportTemplate/GetAllReportTemplates?";
        if (report !== undefined && report !== null)
            url_ += "report=" + encodeURIComponent("" + report) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReportTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReportTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllReportTemplatesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllReportTemplatesResponse>;
        }));
    }

    protected processGetAllReportTemplates(response: HttpResponseBase): Observable<GetAllReportTemplatesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllReportTemplatesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReportTemplate(request: UpdateReportTemplateRequest): Observable<UpdateReportTemplateResponse> {
        let url_ = this.baseUrl + "/v1/ReportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateReportTemplateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateReportTemplateResponse>;
        }));
    }

    protected processUpdateReportTemplate(response: HttpResponseBase): Observable<UpdateReportTemplateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateReportTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteReportTemplate(id?: number | undefined): Observable<DeleteReportTemplateResponse> {
        let url_ = this.baseUrl + "/v1/ReportTemplate/DeleteReportTemplate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteReportTemplateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteReportTemplateResponse>;
        }));
    }

    protected processDeleteReportTemplate(response: HttpResponseBase): Observable<DeleteReportTemplateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteReportTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserCostCenterClient {
    getUserCostCentersByExternalId(externalId?: string | null | undefined): Observable<GetUserCostCentersResponse>;
    addUserCostCenter(addRadarUserCostCenter: AddRadarUserCostCenter): Observable<GetUserCostCentersResponse>;
    removeCostCenter(removeRadarUserCostCenter: RemoveRadarUserCostCenter): Observable<GetUserCostCentersResponse>;
    updateCostCenters(externalId?: string | null | undefined): Observable<UpdateCostCentersFromUserRequestResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UserCostCenterClient implements IUserCostCenterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getUserCostCentersByExternalId(externalId?: string | null | undefined): Observable<GetUserCostCentersResponse> {
        let url_ = this.baseUrl + "/v1/UserCostCenter/GetUserCostCentersByExternalId?";
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCostCentersByExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCostCentersByExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserCostCentersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserCostCentersResponse>;
        }));
    }

    protected processGetUserCostCentersByExternalId(response: HttpResponseBase): Observable<GetUserCostCentersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserCostCentersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUserCostCenter(addRadarUserCostCenter: AddRadarUserCostCenter): Observable<GetUserCostCentersResponse> {
        let url_ = this.baseUrl + "/v1/UserCostCenter/AddUserCostCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addRadarUserCostCenter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserCostCenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserCostCenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserCostCentersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserCostCentersResponse>;
        }));
    }

    protected processAddUserCostCenter(response: HttpResponseBase): Observable<GetUserCostCentersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserCostCentersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCostCenter(removeRadarUserCostCenter: RemoveRadarUserCostCenter): Observable<GetUserCostCentersResponse> {
        let url_ = this.baseUrl + "/v1/UserCostCenter/RemoveCostCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeRadarUserCostCenter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCostCenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCostCenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserCostCentersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserCostCentersResponse>;
        }));
    }

    protected processRemoveCostCenter(response: HttpResponseBase): Observable<GetUserCostCentersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserCostCentersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCostCenters(externalId?: string | null | undefined): Observable<UpdateCostCentersFromUserRequestResponse> {
        let url_ = this.baseUrl + "/v1/UserCostCenter/UpdateCostCenters?";
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCostCentersFromUserRequestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCostCentersFromUserRequestResponse>;
        }));
    }

    protected processUpdateCostCenters(response: HttpResponseBase): Observable<UpdateCostCentersFromUserRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCostCentersFromUserRequestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFeatureFlagsClient {
    get(): Observable<Feature[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagsClient implements IFeatureFlagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(): Observable<Feature[]> {
        let url_ = this.baseUrl + "/FeatureFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Feature[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Feature[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Feature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailClient {
    sendEmail(request: SendEmailRequest): Observable<SendEmailResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient implements IEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    sendEmail(request: SendEmailRequest): Observable<SendEmailResponse> {
        let url_ = this.baseUrl + "/v1/Email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailResponse>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<SendEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeeClient {
    get(firstName?: string | null | undefined, lastName?: string | null | undefined): Observable<GetEmployeesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient implements IEmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(firstName?: string | null | undefined, lastName?: string | null | undefined): Observable<GetEmployeesResponse> {
        let url_ = this.baseUrl + "/v1/Employee?";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetEmployeesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoleClient {
    get(): Observable<GetRolesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(): Observable<GetRolesResponse> {
        let url_ = this.baseUrl + "/v1/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRolesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRolesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRolesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRolesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    updateUserFromToken(userFromTokenRequest: UpdateUserFromTokenRequest): Observable<void>;
    getCurrentUserRolePermissions(): Observable<GetUserResponse>;
    isUserInGroup(emailAddress?: string | null | undefined): Observable<IsUserInGroupResponse>;
    getAllUsers(): Observable<GetAllUsersResponse>;
    updateUserRoleAndStatus(request: UpdateUserRoleAndStatusRequest): Observable<UpdateUserRoleAndStatusResponse>;
    createUser(addUserRequest: AddUserRequest): Observable<AddUserResponse>;
    getAllUsers2(): Observable<GetAllUsersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    updateUserFromToken(userFromTokenRequest: UpdateUserFromTokenRequest): Observable<void> {
        let url_ = this.baseUrl + "/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userFromTokenRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserFromToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserFromToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserFromToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUserRolePermissions(): Observable<GetUserResponse> {
        let url_ = this.baseUrl + "/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserResponse>;
        }));
    }

    protected processGetCurrentUserRolePermissions(response: HttpResponseBase): Observable<GetUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isUserInGroup(emailAddress?: string | null | undefined): Observable<IsUserInGroupResponse> {
        let url_ = this.baseUrl + "/v1/User/IsUserInGroup?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserInGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserInGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsUserInGroupResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsUserInGroupResponse>;
        }));
    }

    protected processIsUserInGroup(response: HttpResponseBase): Observable<IsUserInGroupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsUserInGroupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllUsers(): Observable<GetAllUsersResponse> {
        let url_ = this.baseUrl + "/v1/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllUsersResponse>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<GetAllUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserRoleAndStatus(request: UpdateUserRoleAndStatusRequest): Observable<UpdateUserRoleAndStatusResponse> {
        let url_ = this.baseUrl + "/v1/User/UpdateUserRoleAndStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRoleAndStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRoleAndStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserRoleAndStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserRoleAndStatusResponse>;
        }));
    }

    protected processUpdateUserRoleAndStatus(response: HttpResponseBase): Observable<UpdateUserRoleAndStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserRoleAndStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUser(addUserRequest: AddUserRequest): Observable<AddUserResponse> {
        let url_ = this.baseUrl + "/v1/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addUserRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddUserResponse>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<AddUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllUsers2(): Observable<GetAllUsersResponse> {
        let url_ = this.baseUrl + "/v2/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllUsersResponse>;
        }));
    }

    protected processGetAllUsers2(response: HttpResponseBase): Observable<GetAllUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUtilityClient {
    getUtilities(discriminator?: UtilityTables | undefined, id?: number | null | undefined, sortDirection?: SortDirection | null | undefined, sortBy?: string | null | undefined): Observable<GetUtilitiesResponse>;
    createUtility(request: CreateUtilityRequest): Observable<CreateUtilityResponse>;
    updateUtility(request: UpdateUtilityRequest): Observable<UpdateUtilityResponse>;
    deleteUtility(discriminator: UtilityTables, id: number): Observable<DeleteUtilityResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UtilityClient implements IUtilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getUtilities(discriminator?: UtilityTables | undefined, id?: number | null | undefined, sortDirection?: SortDirection | null | undefined, sortBy?: string | null | undefined): Observable<GetUtilitiesResponse> {
        let url_ = this.baseUrl + "/v1/Utility?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUtilitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUtilitiesResponse>;
        }));
    }

    protected processGetUtilities(response: HttpResponseBase): Observable<GetUtilitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUtilitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createUtility(request: CreateUtilityRequest): Observable<CreateUtilityResponse> {
        let url_ = this.baseUrl + "/v1/Utility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUtilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUtilityResponse>;
        }));
    }

    protected processCreateUtility(response: HttpResponseBase): Observable<CreateUtilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUtilityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUtility(request: UpdateUtilityRequest): Observable<UpdateUtilityResponse> {
        let url_ = this.baseUrl + "/v1/Utility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUtilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUtilityResponse>;
        }));
    }

    protected processUpdateUtility(response: HttpResponseBase): Observable<UpdateUtilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUtilityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUtility(discriminator: UtilityTables, id: number): Observable<DeleteUtilityResponse> {
        let url_ = this.baseUrl + "/v1/Utility/{discriminator}/{id}";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined.");
        url_ = url_.replace("{discriminator}", encodeURIComponent("" + discriminator));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUtility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUtility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteUtilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteUtilityResponse>;
        }));
    }

    protected processDeleteUtility(response: HttpResponseBase): Observable<DeleteUtilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteUtilityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPersonClient {
    getPersons(): Observable<GetPersonsResponse>;
    getPersonById(id?: number | undefined): Observable<GetPersonResponse>;
    getMatchingPersonsStartsWith(firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, title?: string | null | undefined, department?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, wustlEduId?: string | null | undefined, commonsID?: string | null | undefined, oRCID?: string | null | undefined, phone?: string | null | undefined, costCenterHierarchy?: string | null | undefined, projectPersons?: ProjectPerson[] | null | undefined, inKinds?: InKind[] | null | undefined, isDeleted?: boolean | null | undefined, id?: number | undefined, createdDate?: Date | undefined, lastUpdatedDate?: Date | undefined, updateUserId?: string | null | undefined): Observable<GetPersonsResponse>;
    getMatchingPersonsContains(firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, title?: string | null | undefined, department?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, wustlEduId?: string | null | undefined, commonsID?: string | null | undefined, oRCID?: string | null | undefined, phone?: string | null | undefined, costCenterHierarchy?: string | null | undefined, projectPersons?: ProjectPerson[] | null | undefined, inKinds?: InKind[] | null | undefined, isDeleted?: boolean | null | undefined, id?: number | undefined, createdDate?: Date | undefined, lastUpdatedDate?: Date | undefined, updateUserId?: string | null | undefined): Observable<GetPersonsResponse>;
    getResearcherList(searchString?: string | null | undefined, useMuleSoft?: boolean | undefined): Observable<GetResearchersListResponse>;
    updateReportPersonName(updateReportPersonNameRequest: UpdateReportPersonNameRequest): Observable<ReportPersonVM>;
    updateReportPersonCommonsId(updateReportPersonCommonsId: UpdateReportPersonCommonsId): Observable<ReportPersonVM>;
    updateUserFromMuleSoft(updateReportPersonCommonsId: UpdateReportPersonCommonsId): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class PersonClient implements IPersonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPersons(): Observable<GetPersonsResponse> {
        let url_ = this.baseUrl + "/v1/Person";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonsResponse>;
        }));
    }

    protected processGetPersons(response: HttpResponseBase): Observable<GetPersonsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonById(id?: number | undefined): Observable<GetPersonResponse> {
        let url_ = this.baseUrl + "/v1/Person/GetPersonById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonResponse>;
        }));
    }

    protected processGetPersonById(response: HttpResponseBase): Observable<GetPersonResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMatchingPersonsStartsWith(firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, title?: string | null | undefined, department?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, wustlEduId?: string | null | undefined, commonsID?: string | null | undefined, oRCID?: string | null | undefined, phone?: string | null | undefined, costCenterHierarchy?: string | null | undefined, projectPersons?: ProjectPerson[] | null | undefined, inKinds?: InKind[] | null | undefined, isDeleted?: boolean | null | undefined, id?: number | undefined, createdDate?: Date | undefined, lastUpdatedDate?: Date | undefined, updateUserId?: string | null | undefined): Observable<GetPersonsResponse> {
        let url_ = this.baseUrl + "/v1/Person/GetMatchingPersonsStartsWith?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (wustlEduId !== undefined && wustlEduId !== null)
            url_ += "WustlEduId=" + encodeURIComponent("" + wustlEduId) + "&";
        if (commonsID !== undefined && commonsID !== null)
            url_ += "CommonsID=" + encodeURIComponent("" + commonsID) + "&";
        if (oRCID !== undefined && oRCID !== null)
            url_ += "ORCID=" + encodeURIComponent("" + oRCID) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (costCenterHierarchy !== undefined && costCenterHierarchy !== null)
            url_ += "CostCenterHierarchy=" + encodeURIComponent("" + costCenterHierarchy) + "&";
        if (projectPersons !== undefined && projectPersons !== null)
            projectPersons && projectPersons.forEach(item => { url_ += "ProjectPersons=" + encodeURIComponent("" + item) + "&"; });
        if (inKinds !== undefined && inKinds !== null)
            inKinds && inKinds.forEach(item => { url_ += "InKinds=" + encodeURIComponent("" + item) + "&"; });
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdDate === null)
            throw new Error("The parameter 'createdDate' cannot be null.");
        else if (createdDate !== undefined)
            url_ += "CreatedDate=" + encodeURIComponent(createdDate ? "" + createdDate.toISOString() : "") + "&";
        if (lastUpdatedDate === null)
            throw new Error("The parameter 'lastUpdatedDate' cannot be null.");
        else if (lastUpdatedDate !== undefined)
            url_ += "LastUpdatedDate=" + encodeURIComponent(lastUpdatedDate ? "" + lastUpdatedDate.toISOString() : "") + "&";
        if (updateUserId !== undefined && updateUserId !== null)
            url_ += "UpdateUserId=" + encodeURIComponent("" + updateUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingPersonsStartsWith(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingPersonsStartsWith(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonsResponse>;
        }));
    }

    protected processGetMatchingPersonsStartsWith(response: HttpResponseBase): Observable<GetPersonsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMatchingPersonsContains(firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, title?: string | null | undefined, department?: string | null | undefined, email?: string | null | undefined, employeeId?: string | null | undefined, wustlEduId?: string | null | undefined, commonsID?: string | null | undefined, oRCID?: string | null | undefined, phone?: string | null | undefined, costCenterHierarchy?: string | null | undefined, projectPersons?: ProjectPerson[] | null | undefined, inKinds?: InKind[] | null | undefined, isDeleted?: boolean | null | undefined, id?: number | undefined, createdDate?: Date | undefined, lastUpdatedDate?: Date | undefined, updateUserId?: string | null | undefined): Observable<GetPersonsResponse> {
        let url_ = this.baseUrl + "/v1/Person/GetMatchingPersonsContains?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (wustlEduId !== undefined && wustlEduId !== null)
            url_ += "WustlEduId=" + encodeURIComponent("" + wustlEduId) + "&";
        if (commonsID !== undefined && commonsID !== null)
            url_ += "CommonsID=" + encodeURIComponent("" + commonsID) + "&";
        if (oRCID !== undefined && oRCID !== null)
            url_ += "ORCID=" + encodeURIComponent("" + oRCID) + "&";
        if (phone !== undefined && phone !== null)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (costCenterHierarchy !== undefined && costCenterHierarchy !== null)
            url_ += "CostCenterHierarchy=" + encodeURIComponent("" + costCenterHierarchy) + "&";
        if (projectPersons !== undefined && projectPersons !== null)
            projectPersons && projectPersons.forEach(item => { url_ += "ProjectPersons=" + encodeURIComponent("" + item) + "&"; });
        if (inKinds !== undefined && inKinds !== null)
            inKinds && inKinds.forEach(item => { url_ += "InKinds=" + encodeURIComponent("" + item) + "&"; });
        if (isDeleted !== undefined && isDeleted !== null)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (createdDate === null)
            throw new Error("The parameter 'createdDate' cannot be null.");
        else if (createdDate !== undefined)
            url_ += "CreatedDate=" + encodeURIComponent(createdDate ? "" + createdDate.toISOString() : "") + "&";
        if (lastUpdatedDate === null)
            throw new Error("The parameter 'lastUpdatedDate' cannot be null.");
        else if (lastUpdatedDate !== undefined)
            url_ += "LastUpdatedDate=" + encodeURIComponent(lastUpdatedDate ? "" + lastUpdatedDate.toISOString() : "") + "&";
        if (updateUserId !== undefined && updateUserId !== null)
            url_ += "UpdateUserId=" + encodeURIComponent("" + updateUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingPersonsContains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingPersonsContains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonsResponse>;
        }));
    }

    protected processGetMatchingPersonsContains(response: HttpResponseBase): Observable<GetPersonsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResearcherList(searchString?: string | null | undefined, useMuleSoft?: boolean | undefined): Observable<GetResearchersListResponse> {
        let url_ = this.baseUrl + "/v1/Person/GetResearcherList?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (useMuleSoft === null)
            throw new Error("The parameter 'useMuleSoft' cannot be null.");
        else if (useMuleSoft !== undefined)
            url_ += "useMuleSoft=" + encodeURIComponent("" + useMuleSoft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResearcherList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResearcherList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResearchersListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResearchersListResponse>;
        }));
    }

    protected processGetResearcherList(response: HttpResponseBase): Observable<GetResearchersListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResearchersListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReportPersonName(updateReportPersonNameRequest: UpdateReportPersonNameRequest): Observable<ReportPersonVM> {
        let url_ = this.baseUrl + "/v1/Person/UpdateReportPersonName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateReportPersonNameRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportPersonName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportPersonName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportPersonVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportPersonVM>;
        }));
    }

    protected processUpdateReportPersonName(response: HttpResponseBase): Observable<ReportPersonVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPersonVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateReportPersonCommonsId(updateReportPersonCommonsId: UpdateReportPersonCommonsId): Observable<ReportPersonVM> {
        let url_ = this.baseUrl + "/v1/Person/UpdateReportPersonCommonsId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateReportPersonCommonsId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportPersonCommonsId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportPersonCommonsId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportPersonVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportPersonVM>;
        }));
    }

    protected processUpdateReportPersonCommonsId(response: HttpResponseBase): Observable<ReportPersonVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPersonVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserFromMuleSoft(updateReportPersonCommonsId: UpdateReportPersonCommonsId): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Person/UpdateUserFromMuleSoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateReportPersonCommonsId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserFromMuleSoft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserFromMuleSoft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUserFromMuleSoft(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectEffortClient {
    getProjectPersonEfforts(projectPersonId?: number | undefined): Observable<GetProjectPersonEffortsResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectEffortClient implements IProjectEffortClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getProjectPersonEfforts(projectPersonId?: number | undefined): Observable<GetProjectPersonEffortsResponse> {
        let url_ = this.baseUrl + "/v1/ProjectEffort/GetProjectPersonEfforts?";
        if (projectPersonId === null)
            throw new Error("The parameter 'projectPersonId' cannot be null.");
        else if (projectPersonId !== undefined)
            url_ += "projectPersonId=" + encodeURIComponent("" + projectPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectPersonEfforts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectPersonEfforts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectPersonEffortsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectPersonEffortsResponse>;
        }));
    }

    protected processGetProjectPersonEfforts(response: HttpResponseBase): Observable<GetProjectPersonEffortsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectPersonEffortsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddOrUpdateHelpLinkResponse implements IAddOrUpdateHelpLinkResponse {
    helpLinks?: HelpLinkVM[] | null;

    constructor(data?: IAddOrUpdateHelpLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["helpLinks"])) {
                this.helpLinks = [] as any;
                for (let item of _data["helpLinks"])
                    this.helpLinks!.push(HelpLinkVM.fromJS(item));
            }
            else {
                this.helpLinks = <any>null;
            }
        }
    }

    static fromJS(data: any): AddOrUpdateHelpLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateHelpLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.helpLinks)) {
            data["helpLinks"] = [];
            for (let item of this.helpLinks)
                data["helpLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddOrUpdateHelpLinkResponse {
    helpLinks?: HelpLinkVM[] | null;
}

export class HelpLinkVM implements IHelpLinkVM {
    id?: number;
    linkDesc?: string | null;
    linkUrl?: string | null;
    orderNum?: number;

    constructor(data?: IHelpLinkVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.linkDesc = _data["linkDesc"] !== undefined ? _data["linkDesc"] : <any>null;
            this.linkUrl = _data["linkUrl"] !== undefined ? _data["linkUrl"] : <any>null;
            this.orderNum = _data["orderNum"] !== undefined ? _data["orderNum"] : <any>null;
        }
    }

    static fromJS(data: any): HelpLinkVM {
        data = typeof data === 'object' ? data : {};
        let result = new HelpLinkVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["linkDesc"] = this.linkDesc !== undefined ? this.linkDesc : <any>null;
        data["linkUrl"] = this.linkUrl !== undefined ? this.linkUrl : <any>null;
        data["orderNum"] = this.orderNum !== undefined ? this.orderNum : <any>null;
        return data;
    }
}

export interface IHelpLinkVM {
    id?: number;
    linkDesc?: string | null;
    linkUrl?: string | null;
    orderNum?: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ApiError extends ProblemDetails implements IApiError {
    error?: string | null;
    errorKey?: any | null;

    [key: string]: any;

    constructor(data?: IApiError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : <any>null;
        }
    }

    static override fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IApiError extends IProblemDetails {
    error?: string | null;
    errorKey?: any | null;

    [key: string]: any;
}

export class AddOrUpdateHelpLinkRequest implements IAddOrUpdateHelpLinkRequest {
    helpLinks?: HelpLinkVM[] | null;

    constructor(data?: IAddOrUpdateHelpLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["helpLinks"])) {
                this.helpLinks = [] as any;
                for (let item of _data["helpLinks"])
                    this.helpLinks!.push(HelpLinkVM.fromJS(item));
            }
            else {
                this.helpLinks = <any>null;
            }
        }
    }

    static fromJS(data: any): AddOrUpdateHelpLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateHelpLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.helpLinks)) {
            data["helpLinks"] = [];
            for (let item of this.helpLinks)
                data["helpLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddOrUpdateHelpLinkRequest {
    helpLinks?: HelpLinkVM[] | null;
}

export class GetHelpLinksResponse implements IGetHelpLinksResponse {
    helpLinks?: HelpLinkVM[] | null;

    constructor(data?: IGetHelpLinksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["helpLinks"])) {
                this.helpLinks = [] as any;
                for (let item of _data["helpLinks"])
                    this.helpLinks!.push(HelpLinkVM.fromJS(item));
            }
            else {
                this.helpLinks = <any>null;
            }
        }
    }

    static fromJS(data: any): GetHelpLinksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHelpLinksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.helpLinks)) {
            data["helpLinks"] = [];
            for (let item of this.helpLinks)
                data["helpLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetHelpLinksResponse {
    helpLinks?: HelpLinkVM[] | null;
}

export class DeleteHelpLinkResponse implements IDeleteHelpLinkResponse {
    isDeleted?: boolean;

    constructor(data?: IDeleteHelpLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteHelpLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteHelpLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }
}

export interface IDeleteHelpLinkResponse {
    isDeleted?: boolean;
}

export class DeleteHelpLinkRequest implements IDeleteHelpLinkRequest {
    id?: number;

    constructor(data?: IDeleteHelpLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteHelpLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteHelpLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteHelpLinkRequest {
    id?: number;
}

export class GetInKindsResponse implements IGetInKindsResponse {
    inKinds?: InKindVM[] | null;

    constructor(data?: IGetInKindsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inKinds"])) {
                this.inKinds = [] as any;
                for (let item of _data["inKinds"])
                    this.inKinds!.push(InKindVM.fromJS(item));
            }
            else {
                this.inKinds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetInKindsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInKindsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inKinds)) {
            data["inKinds"] = [];
            for (let item of this.inKinds)
                data["inKinds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInKindsResponse {
    inKinds?: InKindVM[] | null;
}

export class InKindVM implements IInKindVM {
    id?: number;
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;

    constructor(data?: IInKindVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["inKindEfforts"])) {
                this.inKindEfforts = [] as any;
                for (let item of _data["inKindEfforts"])
                    this.inKindEfforts!.push(InKindEffortVM.fromJS(item));
            }
            else {
                this.inKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
        }
    }

    static fromJS(data: any): InKindVM {
        data = typeof data === 'object' ? data : {};
        let result = new InKindVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.inKindEfforts)) {
            data["inKindEfforts"] = [];
            for (let item of this.inKindEfforts)
                data["inKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        return data;
    }
}

export interface IInKindVM {
    id?: number;
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
}

export class InKindEffortVM implements IInKindEffortVM {
    id?: number;
    inKindId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;

    constructor(data?: IInKindEffortVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
        }
    }

    static fromJS(data: any): InKindEffortVM {
        data = typeof data === 'object' ? data : {};
        let result = new InKindEffortVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        return data;
    }
}

export interface IInKindEffortVM {
    id?: number;
    inKindId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;
}

export class GetInKindByIdResponse implements IGetInKindByIdResponse {
    inKind?: InKindVM | null;

    constructor(data?: IGetInKindByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inKind = _data["inKind"] ? InKindVM.fromJS(_data["inKind"]) : <any>null;
        }
    }

    static fromJS(data: any): GetInKindByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInKindByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inKind"] = this.inKind ? this.inKind.toJSON() : <any>null;
        return data;
    }
}

export interface IGetInKindByIdResponse {
    inKind?: InKindVM | null;
}

export class CreateInKindResponse implements ICreateInKindResponse {
    id?: number;

    constructor(data?: ICreateInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ICreateInKindResponse {
    id?: number;
}

export class CreateInKindRequest implements ICreateInKindRequest {
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;

    constructor(data?: ICreateInKindRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["inKindEfforts"])) {
                this.inKindEfforts = [] as any;
                for (let item of _data["inKindEfforts"])
                    this.inKindEfforts!.push(InKindEffortVM.fromJS(item));
            }
            else {
                this.inKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInKindRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInKindRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.inKindEfforts)) {
            data["inKindEfforts"] = [];
            for (let item of this.inKindEfforts)
                data["inKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        return data;
    }
}

export interface ICreateInKindRequest {
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;
}

export class UpdateInKindResponse implements IUpdateInKindResponse {
    id?: number;

    constructor(data?: IUpdateInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IUpdateInKindResponse {
    id?: number;
}

export class UpdateInKindRequest implements IUpdateInKindRequest {
    id?: number;
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;

    constructor(data?: IUpdateInKindRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["inKindEfforts"])) {
                this.inKindEfforts = [] as any;
                for (let item of _data["inKindEfforts"])
                    this.inKindEfforts!.push(InKindEffortVM.fromJS(item));
            }
            else {
                this.inKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateInKindRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInKindRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.inKindEfforts)) {
            data["inKindEfforts"] = [];
            for (let item of this.inKindEfforts)
                data["inKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        return data;
    }
}

export interface IUpdateInKindRequest {
    id?: number;
    personId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffortVM[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;
}

export class DeleteInKindResponse implements IDeleteInKindResponse {
    id?: number;

    constructor(data?: IDeleteInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteInKindResponse {
    id?: number;
}

export class OrgInfoVM implements IOrgInfoVM {
    costCenterOrgId?: string | null;
    parentCostCenterOrgId?: string | null;
    name?: string | null;

    constructor(data?: IOrgInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterOrgId = _data["costCenterOrgId"] !== undefined ? _data["costCenterOrgId"] : <any>null;
            this.parentCostCenterOrgId = _data["parentCostCenterOrgId"] !== undefined ? _data["parentCostCenterOrgId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): OrgInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new OrgInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterOrgId"] = this.costCenterOrgId !== undefined ? this.costCenterOrgId : <any>null;
        data["parentCostCenterOrgId"] = this.parentCostCenterOrgId !== undefined ? this.parentCostCenterOrgId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IOrgInfoVM {
    costCenterOrgId?: string | null;
    parentCostCenterOrgId?: string | null;
    name?: string | null;
}

export class ProjectMasterListItem implements IProjectMasterListItem {
    id?: number;
    isSub?: boolean;
    subProjectTitle?: string | null;
    isArchived?: boolean;
    isDeleted?: boolean | null;
    title?: string | null;
    sourceOfSupport?: string | null;
    status?: string | null;
    totalAwardAmount?: number;
    startDate?: Date | null;
    endDate?: Date | null;

    constructor(data?: IProjectMasterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isSub = _data["isSub"] !== undefined ? _data["isSub"] : <any>null;
            this.subProjectTitle = _data["subProjectTitle"] !== undefined ? _data["subProjectTitle"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.totalAwardAmount = _data["totalAwardAmount"] !== undefined ? _data["totalAwardAmount"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ProjectMasterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMasterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isSub"] = this.isSub !== undefined ? this.isSub : <any>null;
        data["subProjectTitle"] = this.subProjectTitle !== undefined ? this.subProjectTitle : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["totalAwardAmount"] = this.totalAwardAmount !== undefined ? this.totalAwardAmount : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IProjectMasterListItem {
    id?: number;
    isSub?: boolean;
    subProjectTitle?: string | null;
    isArchived?: boolean;
    isDeleted?: boolean | null;
    title?: string | null;
    sourceOfSupport?: string | null;
    status?: string | null;
    totalAwardAmount?: number;
    startDate?: Date | null;
    endDate?: Date | null;
}

export class GetProjectByIdResponse implements IGetProjectByIdResponse {
    project?: ProjectVM | null;

    constructor(data?: IGetProjectByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectVM.fromJS(_data["project"]) : <any>null;
        }
    }

    static fromJS(data: any): GetProjectByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>null;
        return data;
    }
}

export interface IGetProjectByIdResponse {
    project?: ProjectVM | null;
}

export class ProjectVM implements IProjectVM {
    id?: number;
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    isSubProject?: boolean;
    awardNickname?: string | null;
    sourceOfSupport?: string | null;
    originatingSponsor?: string | null;
    fain?: string | null;
    directCost?: number | null;
    indirectCost?: number | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    overlap?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    projectPersons?: ProjectPersonVM[] | null;
    projectAssociatedCch?: ProjectAssociatedCchVM[] | null;
    multiplePIs?: ProjectMultiplePIsVM[] | null;
    subProjectMultipleLeaders?: SubProjectMultipleLeadersVM[] | null;
    projectEfforts?: ProjectEffortVM[] | null;
    isArchived?: boolean;
    internalNotes?: string | null;

    constructor(data?: IProjectVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.subProjectTitle = _data["subProjectTitle"] !== undefined ? _data["subProjectTitle"] : <any>null;
            this.majorGoals = _data["majorGoals"] !== undefined ? _data["majorGoals"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.projectNumber = _data["projectNumber"] !== undefined ? _data["projectNumber"] : <any>null;
            this.projectNumberRMS = _data["projectNumberRMS"] !== undefined ? _data["projectNumberRMS"] : <any>null;
            this.projectNumberWD = _data["projectNumberWD"] !== undefined ? _data["projectNumberWD"] : <any>null;
            this.piLastName = _data["piLastName"] !== undefined ? _data["piLastName"] : <any>null;
            this.piFirstName = _data["piFirstName"] !== undefined ? _data["piFirstName"] : <any>null;
            this.subLeaderLastName = _data["subLeaderLastName"] !== undefined ? _data["subLeaderLastName"] : <any>null;
            this.subLeaderFirstName = _data["subLeaderFirstName"] !== undefined ? _data["subLeaderFirstName"] : <any>null;
            this.isSubProject = _data["isSubProject"] !== undefined ? _data["isSubProject"] : <any>null;
            this.awardNickname = _data["awardNickname"] !== undefined ? _data["awardNickname"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.originatingSponsor = _data["originatingSponsor"] !== undefined ? _data["originatingSponsor"] : <any>null;
            this.fain = _data["fain"] !== undefined ? _data["fain"] : <any>null;
            this.directCost = _data["directCost"] !== undefined ? _data["directCost"] : <any>null;
            this.indirectCost = _data["indirectCost"] !== undefined ? _data["indirectCost"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateProvince = _data["stateProvince"] !== undefined ? _data["stateProvince"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.totalAwardAmount = _data["totalAwardAmount"] !== undefined ? _data["totalAwardAmount"] : <any>null;
            if (Array.isArray(_data["projectPersons"])) {
                this.projectPersons = [] as any;
                for (let item of _data["projectPersons"])
                    this.projectPersons!.push(ProjectPersonVM.fromJS(item));
            }
            else {
                this.projectPersons = <any>null;
            }
            if (Array.isArray(_data["projectAssociatedCch"])) {
                this.projectAssociatedCch = [] as any;
                for (let item of _data["projectAssociatedCch"])
                    this.projectAssociatedCch!.push(ProjectAssociatedCchVM.fromJS(item));
            }
            else {
                this.projectAssociatedCch = <any>null;
            }
            if (Array.isArray(_data["multiplePIs"])) {
                this.multiplePIs = [] as any;
                for (let item of _data["multiplePIs"])
                    this.multiplePIs!.push(ProjectMultiplePIsVM.fromJS(item));
            }
            else {
                this.multiplePIs = <any>null;
            }
            if (Array.isArray(_data["subProjectMultipleLeaders"])) {
                this.subProjectMultipleLeaders = [] as any;
                for (let item of _data["subProjectMultipleLeaders"])
                    this.subProjectMultipleLeaders!.push(SubProjectMultipleLeadersVM.fromJS(item));
            }
            else {
                this.subProjectMultipleLeaders = <any>null;
            }
            if (Array.isArray(_data["projectEfforts"])) {
                this.projectEfforts = [] as any;
                for (let item of _data["projectEfforts"])
                    this.projectEfforts!.push(ProjectEffortVM.fromJS(item));
            }
            else {
                this.projectEfforts = <any>null;
            }
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["subProjectTitle"] = this.subProjectTitle !== undefined ? this.subProjectTitle : <any>null;
        data["majorGoals"] = this.majorGoals !== undefined ? this.majorGoals : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["projectNumber"] = this.projectNumber !== undefined ? this.projectNumber : <any>null;
        data["projectNumberRMS"] = this.projectNumberRMS !== undefined ? this.projectNumberRMS : <any>null;
        data["projectNumberWD"] = this.projectNumberWD !== undefined ? this.projectNumberWD : <any>null;
        data["piLastName"] = this.piLastName !== undefined ? this.piLastName : <any>null;
        data["piFirstName"] = this.piFirstName !== undefined ? this.piFirstName : <any>null;
        data["subLeaderLastName"] = this.subLeaderLastName !== undefined ? this.subLeaderLastName : <any>null;
        data["subLeaderFirstName"] = this.subLeaderFirstName !== undefined ? this.subLeaderFirstName : <any>null;
        data["isSubProject"] = this.isSubProject !== undefined ? this.isSubProject : <any>null;
        data["awardNickname"] = this.awardNickname !== undefined ? this.awardNickname : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["originatingSponsor"] = this.originatingSponsor !== undefined ? this.originatingSponsor : <any>null;
        data["fain"] = this.fain !== undefined ? this.fain : <any>null;
        data["directCost"] = this.directCost !== undefined ? this.directCost : <any>null;
        data["indirectCost"] = this.indirectCost !== undefined ? this.indirectCost : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateProvince"] = this.stateProvince !== undefined ? this.stateProvince : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["totalAwardAmount"] = this.totalAwardAmount !== undefined ? this.totalAwardAmount : <any>null;
        if (Array.isArray(this.projectPersons)) {
            data["projectPersons"] = [];
            for (let item of this.projectPersons)
                data["projectPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.projectAssociatedCch)) {
            data["projectAssociatedCch"] = [];
            for (let item of this.projectAssociatedCch)
                data["projectAssociatedCch"].push(item.toJSON());
        }
        if (Array.isArray(this.multiplePIs)) {
            data["multiplePIs"] = [];
            for (let item of this.multiplePIs)
                data["multiplePIs"].push(item.toJSON());
        }
        if (Array.isArray(this.subProjectMultipleLeaders)) {
            data["subProjectMultipleLeaders"] = [];
            for (let item of this.subProjectMultipleLeaders)
                data["subProjectMultipleLeaders"].push(item.toJSON());
        }
        if (Array.isArray(this.projectEfforts)) {
            data["projectEfforts"] = [];
            for (let item of this.projectEfforts)
                data["projectEfforts"].push(item.toJSON());
        }
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        return data;
    }
}

export interface IProjectVM {
    id?: number;
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    isSubProject?: boolean;
    awardNickname?: string | null;
    sourceOfSupport?: string | null;
    originatingSponsor?: string | null;
    fain?: string | null;
    directCost?: number | null;
    indirectCost?: number | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    overlap?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    projectPersons?: ProjectPersonVM[] | null;
    projectAssociatedCch?: ProjectAssociatedCchVM[] | null;
    multiplePIs?: ProjectMultiplePIsVM[] | null;
    subProjectMultipleLeaders?: SubProjectMultipleLeadersVM[] | null;
    projectEfforts?: ProjectEffortVM[] | null;
    isArchived?: boolean;
    internalNotes?: string | null;
}

export class ProjectPersonVM implements IProjectPersonVM {
    id?: number;
    projectId?: number;
    personId?: number;
    projectRole?: string | null;
    projectRoleDesc?: string | null;
    effortNotes?: string | null;
    personNotes?: string | null;
    key?: boolean;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    person?: PersonVM | null;
    projectEfforts?: ProjectEffortVM[] | null;

    constructor(data?: IProjectPersonVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.projectRole = _data["projectRole"] !== undefined ? _data["projectRole"] : <any>null;
            this.projectRoleDesc = _data["projectRoleDesc"] !== undefined ? _data["projectRoleDesc"] : <any>null;
            this.effortNotes = _data["effortNotes"] !== undefined ? _data["effortNotes"] : <any>null;
            this.personNotes = _data["personNotes"] !== undefined ? _data["personNotes"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.grantNumber = _data["grantNumber"] !== undefined ? _data["grantNumber"] : <any>null;
            this.grantNumberDetail = _data["grantNumberDetail"] !== undefined ? _data["grantNumberDetail"] : <any>null;
            this.person = _data["person"] ? PersonVM.fromJS(_data["person"]) : <any>null;
            if (Array.isArray(_data["projectEfforts"])) {
                this.projectEfforts = [] as any;
                for (let item of _data["projectEfforts"])
                    this.projectEfforts!.push(ProjectEffortVM.fromJS(item));
            }
            else {
                this.projectEfforts = <any>null;
            }
        }
    }

    static fromJS(data: any): ProjectPersonVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPersonVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["projectRole"] = this.projectRole !== undefined ? this.projectRole : <any>null;
        data["projectRoleDesc"] = this.projectRoleDesc !== undefined ? this.projectRoleDesc : <any>null;
        data["effortNotes"] = this.effortNotes !== undefined ? this.effortNotes : <any>null;
        data["personNotes"] = this.personNotes !== undefined ? this.personNotes : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["grantNumber"] = this.grantNumber !== undefined ? this.grantNumber : <any>null;
        data["grantNumberDetail"] = this.grantNumberDetail !== undefined ? this.grantNumberDetail : <any>null;
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        if (Array.isArray(this.projectEfforts)) {
            data["projectEfforts"] = [];
            for (let item of this.projectEfforts)
                data["projectEfforts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectPersonVM {
    id?: number;
    projectId?: number;
    personId?: number;
    projectRole?: string | null;
    projectRoleDesc?: string | null;
    effortNotes?: string | null;
    personNotes?: string | null;
    key?: boolean;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    person?: PersonVM | null;
    projectEfforts?: ProjectEffortVM[] | null;
}

export class PersonVM implements IPersonVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    projects?: ProjectVM[] | null;
    inKinds?: InKindVM[] | null;

    constructor(data?: IPersonVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.wustlEduId = _data["wustlEduId"] !== undefined ? _data["wustlEduId"] : <any>null;
            this.commonsID = _data["commonsID"] !== undefined ? _data["commonsID"] : <any>null;
            this.orcid = _data["orcid"] !== undefined ? _data["orcid"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.costCenterHierarchy = _data["costCenterHierarchy"] !== undefined ? _data["costCenterHierarchy"] : <any>null;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectVM.fromJS(item));
            }
            else {
                this.projects = <any>null;
            }
            if (Array.isArray(_data["inKinds"])) {
                this.inKinds = [] as any;
                for (let item of _data["inKinds"])
                    this.inKinds!.push(InKindVM.fromJS(item));
            }
            else {
                this.inKinds = <any>null;
            }
        }
    }

    static fromJS(data: any): PersonVM {
        data = typeof data === 'object' ? data : {};
        let result = new PersonVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["wustlEduId"] = this.wustlEduId !== undefined ? this.wustlEduId : <any>null;
        data["commonsID"] = this.commonsID !== undefined ? this.commonsID : <any>null;
        data["orcid"] = this.orcid !== undefined ? this.orcid : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["costCenterHierarchy"] = this.costCenterHierarchy !== undefined ? this.costCenterHierarchy : <any>null;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.inKinds)) {
            data["inKinds"] = [];
            for (let item of this.inKinds)
                data["inKinds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    projects?: ProjectVM[] | null;
    inKinds?: InKindVM[] | null;
}

export class ProjectEffortVM implements IProjectEffortVM {
    id?: number;
    projectPersonId?: number;
    yearSequence?: string | null;
    year?: number;
    percent?: number;
    months?: number;

    constructor(data?: IProjectEffortVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.projectPersonId = _data["projectPersonId"] !== undefined ? _data["projectPersonId"] : <any>null;
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectEffortVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEffortVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["projectPersonId"] = this.projectPersonId !== undefined ? this.projectPersonId : <any>null;
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        return data;
    }
}

export interface IProjectEffortVM {
    id?: number;
    projectPersonId?: number;
    yearSequence?: string | null;
    year?: number;
    percent?: number;
    months?: number;
}

export class ProjectAssociatedCchVM implements IProjectAssociatedCchVM {
    id?: number;
    projectId?: number;
    name?: string | null;
    costCenterHierarchy?: string | null;

    constructor(data?: IProjectAssociatedCchVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.costCenterHierarchy = _data["costCenterHierarchy"] !== undefined ? _data["costCenterHierarchy"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectAssociatedCchVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAssociatedCchVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["costCenterHierarchy"] = this.costCenterHierarchy !== undefined ? this.costCenterHierarchy : <any>null;
        return data;
    }
}

export interface IProjectAssociatedCchVM {
    id?: number;
    projectId?: number;
    name?: string | null;
    costCenterHierarchy?: string | null;
}

export class ProjectMultiplePIsVM implements IProjectMultiplePIsVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;

    constructor(data?: IProjectMultiplePIsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectMultiplePIsVM {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMultiplePIsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        return data;
    }
}

export interface IProjectMultiplePIsVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;
}

export class SubProjectMultipleLeadersVM implements ISubProjectMultipleLeadersVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;

    constructor(data?: ISubProjectMultipleLeadersVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
        }
    }

    static fromJS(data: any): SubProjectMultipleLeadersVM {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectMultipleLeadersVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        return data;
    }
}

export interface ISubProjectMultipleLeadersVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;
}

export class GetRMSProjectNumbersResponse implements IGetRMSProjectNumbersResponse {
    rmsProjectNumbers?: RmsProjectNumberObj[] | null;

    constructor(data?: IGetRMSProjectNumbersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rmsProjectNumbers"])) {
                this.rmsProjectNumbers = [] as any;
                for (let item of _data["rmsProjectNumbers"])
                    this.rmsProjectNumbers!.push(RmsProjectNumberObj.fromJS(item));
            }
            else {
                this.rmsProjectNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRMSProjectNumbersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRMSProjectNumbersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rmsProjectNumbers)) {
            data["rmsProjectNumbers"] = [];
            for (let item of this.rmsProjectNumbers)
                data["rmsProjectNumbers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRMSProjectNumbersResponse {
    rmsProjectNumbers?: RmsProjectNumberObj[] | null;
}

export class RmsProjectNumberObj implements IRmsProjectNumberObj {
    rmsNumber?: string | null;
    isRMS?: boolean;
    isSub?: boolean;
    createdDate?: Date;

    constructor(data?: IRmsProjectNumberObj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rmsNumber = _data["rmsNumber"] !== undefined ? _data["rmsNumber"] : <any>null;
            this.isRMS = _data["isRMS"] !== undefined ? _data["isRMS"] : <any>null;
            this.isSub = _data["isSub"] !== undefined ? _data["isSub"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): RmsProjectNumberObj {
        data = typeof data === 'object' ? data : {};
        let result = new RmsProjectNumberObj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rmsNumber"] = this.rmsNumber !== undefined ? this.rmsNumber : <any>null;
        data["isRMS"] = this.isRMS !== undefined ? this.isRMS : <any>null;
        data["isSub"] = this.isSub !== undefined ? this.isSub : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }
}

export interface IRmsProjectNumberObj {
    rmsNumber?: string | null;
    isRMS?: boolean;
    isSub?: boolean;
    createdDate?: Date;
}

export class GetProjectAndSubProjectsByRMSNumResponse implements IGetProjectAndSubProjectsByRMSNumResponse {
    subProjects?: ProjectVM[] | null;
    parentProject?: ReportProjectVM | null;

    constructor(data?: IGetProjectAndSubProjectsByRMSNumResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subProjects"])) {
                this.subProjects = [] as any;
                for (let item of _data["subProjects"])
                    this.subProjects!.push(ProjectVM.fromJS(item));
            }
            else {
                this.subProjects = <any>null;
            }
            this.parentProject = _data["parentProject"] ? ReportProjectVM.fromJS(_data["parentProject"]) : <any>null;
        }
    }

    static fromJS(data: any): GetProjectAndSubProjectsByRMSNumResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectAndSubProjectsByRMSNumResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subProjects)) {
            data["subProjects"] = [];
            for (let item of this.subProjects)
                data["subProjects"].push(item.toJSON());
        }
        data["parentProject"] = this.parentProject ? this.parentProject.toJSON() : <any>null;
        return data;
    }
}

export interface IGetProjectAndSubProjectsByRMSNumResponse {
    subProjects?: ProjectVM[] | null;
    parentProject?: ReportProjectVM | null;
}

export class ReportProjectVM implements IReportProjectVM {
    id?: number;
    projectId?: number | null;
    reportId?: number;
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    multiplePIs?: ReportProjectMultiplePIsVM[] | null;
    sourceOfSupport?: string | null;
    originatingSponsor?: string | null;
    fain?: string | null;
    awardNickname?: string | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    directCost?: number | null;
    indirectCost?: number | null;
    reportProjectEfforts?: ReportProjectEffortVM[] | null;
    osrNotes?: string | null;
    effortNotes?: string | null;
    reportAsOfDate?: Date;
    projectRole?: string | null;
    projectRoleDesc?: string | null;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    personnelType?: string | null;
    overlap?: string | null;
    isRMS?: boolean;
    isSub?: boolean;
    reportSubProjectMultipleLeadersVM?: ReportSubProjectMultipleLeadersVM[] | null;

    constructor(data?: IReportProjectVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.subProjectTitle = _data["subProjectTitle"] !== undefined ? _data["subProjectTitle"] : <any>null;
            this.majorGoals = _data["majorGoals"] !== undefined ? _data["majorGoals"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.projectNumber = _data["projectNumber"] !== undefined ? _data["projectNumber"] : <any>null;
            this.projectNumberRMS = _data["projectNumberRMS"] !== undefined ? _data["projectNumberRMS"] : <any>null;
            this.projectNumberWD = _data["projectNumberWD"] !== undefined ? _data["projectNumberWD"] : <any>null;
            this.piLastName = _data["piLastName"] !== undefined ? _data["piLastName"] : <any>null;
            this.piFirstName = _data["piFirstName"] !== undefined ? _data["piFirstName"] : <any>null;
            this.subLeaderLastName = _data["subLeaderLastName"] !== undefined ? _data["subLeaderLastName"] : <any>null;
            this.subLeaderFirstName = _data["subLeaderFirstName"] !== undefined ? _data["subLeaderFirstName"] : <any>null;
            if (Array.isArray(_data["multiplePIs"])) {
                this.multiplePIs = [] as any;
                for (let item of _data["multiplePIs"])
                    this.multiplePIs!.push(ReportProjectMultiplePIsVM.fromJS(item));
            }
            else {
                this.multiplePIs = <any>null;
            }
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.originatingSponsor = _data["originatingSponsor"] !== undefined ? _data["originatingSponsor"] : <any>null;
            this.fain = _data["fain"] !== undefined ? _data["fain"] : <any>null;
            this.awardNickname = _data["awardNickname"] !== undefined ? _data["awardNickname"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateProvince = _data["stateProvince"] !== undefined ? _data["stateProvince"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.totalAwardAmount = _data["totalAwardAmount"] !== undefined ? _data["totalAwardAmount"] : <any>null;
            this.directCost = _data["directCost"] !== undefined ? _data["directCost"] : <any>null;
            this.indirectCost = _data["indirectCost"] !== undefined ? _data["indirectCost"] : <any>null;
            if (Array.isArray(_data["reportProjectEfforts"])) {
                this.reportProjectEfforts = [] as any;
                for (let item of _data["reportProjectEfforts"])
                    this.reportProjectEfforts!.push(ReportProjectEffortVM.fromJS(item));
            }
            else {
                this.reportProjectEfforts = <any>null;
            }
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.effortNotes = _data["effortNotes"] !== undefined ? _data["effortNotes"] : <any>null;
            this.reportAsOfDate = _data["reportAsOfDate"] ? new Date(_data["reportAsOfDate"].toString()) : <any>null;
            this.projectRole = _data["projectRole"] !== undefined ? _data["projectRole"] : <any>null;
            this.projectRoleDesc = _data["projectRoleDesc"] !== undefined ? _data["projectRoleDesc"] : <any>null;
            this.grantNumber = _data["grantNumber"] !== undefined ? _data["grantNumber"] : <any>null;
            this.grantNumberDetail = _data["grantNumberDetail"] !== undefined ? _data["grantNumberDetail"] : <any>null;
            this.personnelType = _data["personnelType"] !== undefined ? _data["personnelType"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.isRMS = _data["isRMS"] !== undefined ? _data["isRMS"] : <any>null;
            this.isSub = _data["isSub"] !== undefined ? _data["isSub"] : <any>null;
            if (Array.isArray(_data["reportSubProjectMultipleLeadersVM"])) {
                this.reportSubProjectMultipleLeadersVM = [] as any;
                for (let item of _data["reportSubProjectMultipleLeadersVM"])
                    this.reportSubProjectMultipleLeadersVM!.push(ReportSubProjectMultipleLeadersVM.fromJS(item));
            }
            else {
                this.reportSubProjectMultipleLeadersVM = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportProjectVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportProjectVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["subProjectTitle"] = this.subProjectTitle !== undefined ? this.subProjectTitle : <any>null;
        data["majorGoals"] = this.majorGoals !== undefined ? this.majorGoals : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["projectNumber"] = this.projectNumber !== undefined ? this.projectNumber : <any>null;
        data["projectNumberRMS"] = this.projectNumberRMS !== undefined ? this.projectNumberRMS : <any>null;
        data["projectNumberWD"] = this.projectNumberWD !== undefined ? this.projectNumberWD : <any>null;
        data["piLastName"] = this.piLastName !== undefined ? this.piLastName : <any>null;
        data["piFirstName"] = this.piFirstName !== undefined ? this.piFirstName : <any>null;
        data["subLeaderLastName"] = this.subLeaderLastName !== undefined ? this.subLeaderLastName : <any>null;
        data["subLeaderFirstName"] = this.subLeaderFirstName !== undefined ? this.subLeaderFirstName : <any>null;
        if (Array.isArray(this.multiplePIs)) {
            data["multiplePIs"] = [];
            for (let item of this.multiplePIs)
                data["multiplePIs"].push(item.toJSON());
        }
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["originatingSponsor"] = this.originatingSponsor !== undefined ? this.originatingSponsor : <any>null;
        data["fain"] = this.fain !== undefined ? this.fain : <any>null;
        data["awardNickname"] = this.awardNickname !== undefined ? this.awardNickname : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateProvince"] = this.stateProvince !== undefined ? this.stateProvince : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["totalAwardAmount"] = this.totalAwardAmount !== undefined ? this.totalAwardAmount : <any>null;
        data["directCost"] = this.directCost !== undefined ? this.directCost : <any>null;
        data["indirectCost"] = this.indirectCost !== undefined ? this.indirectCost : <any>null;
        if (Array.isArray(this.reportProjectEfforts)) {
            data["reportProjectEfforts"] = [];
            for (let item of this.reportProjectEfforts)
                data["reportProjectEfforts"].push(item.toJSON());
        }
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["effortNotes"] = this.effortNotes !== undefined ? this.effortNotes : <any>null;
        data["reportAsOfDate"] = this.reportAsOfDate ? this.reportAsOfDate.toISOString() : <any>null;
        data["projectRole"] = this.projectRole !== undefined ? this.projectRole : <any>null;
        data["projectRoleDesc"] = this.projectRoleDesc !== undefined ? this.projectRoleDesc : <any>null;
        data["grantNumber"] = this.grantNumber !== undefined ? this.grantNumber : <any>null;
        data["grantNumberDetail"] = this.grantNumberDetail !== undefined ? this.grantNumberDetail : <any>null;
        data["personnelType"] = this.personnelType !== undefined ? this.personnelType : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["isRMS"] = this.isRMS !== undefined ? this.isRMS : <any>null;
        data["isSub"] = this.isSub !== undefined ? this.isSub : <any>null;
        if (Array.isArray(this.reportSubProjectMultipleLeadersVM)) {
            data["reportSubProjectMultipleLeadersVM"] = [];
            for (let item of this.reportSubProjectMultipleLeadersVM)
                data["reportSubProjectMultipleLeadersVM"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportProjectVM {
    id?: number;
    projectId?: number | null;
    reportId?: number;
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    multiplePIs?: ReportProjectMultiplePIsVM[] | null;
    sourceOfSupport?: string | null;
    originatingSponsor?: string | null;
    fain?: string | null;
    awardNickname?: string | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    directCost?: number | null;
    indirectCost?: number | null;
    reportProjectEfforts?: ReportProjectEffortVM[] | null;
    osrNotes?: string | null;
    effortNotes?: string | null;
    reportAsOfDate?: Date;
    projectRole?: string | null;
    projectRoleDesc?: string | null;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    personnelType?: string | null;
    overlap?: string | null;
    isRMS?: boolean;
    isSub?: boolean;
    reportSubProjectMultipleLeadersVM?: ReportSubProjectMultipleLeadersVM[] | null;
}

export class ReportProjectMultiplePIsVM implements IReportProjectMultiplePIsVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    reportProjectId?: number;

    constructor(data?: IReportProjectMultiplePIsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.reportProjectId = _data["reportProjectId"] !== undefined ? _data["reportProjectId"] : <any>null;
        }
    }

    static fromJS(data: any): ReportProjectMultiplePIsVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportProjectMultiplePIsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["reportProjectId"] = this.reportProjectId !== undefined ? this.reportProjectId : <any>null;
        return data;
    }
}

export interface IReportProjectMultiplePIsVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    reportProjectId?: number;
}

export class ReportProjectEffortVM implements IReportProjectEffortVM {
    id?: number;
    projectEffortId?: number | null;
    reportProjectId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number | null;
    percent?: number | null;
    rmsMonths?: number | null;
    rmsPercent?: number | null;
    workdayMonths?: number | null;
    workdayPercent?: number | null;

    constructor(data?: IReportProjectEffortVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.projectEffortId = _data["projectEffortId"] !== undefined ? _data["projectEffortId"] : <any>null;
            this.reportProjectId = _data["reportProjectId"] !== undefined ? _data["reportProjectId"] : <any>null;
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
            this.rmsMonths = _data["rmsMonths"] !== undefined ? _data["rmsMonths"] : <any>null;
            this.rmsPercent = _data["rmsPercent"] !== undefined ? _data["rmsPercent"] : <any>null;
            this.workdayMonths = _data["workdayMonths"] !== undefined ? _data["workdayMonths"] : <any>null;
            this.workdayPercent = _data["workdayPercent"] !== undefined ? _data["workdayPercent"] : <any>null;
        }
    }

    static fromJS(data: any): ReportProjectEffortVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportProjectEffortVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["projectEffortId"] = this.projectEffortId !== undefined ? this.projectEffortId : <any>null;
        data["reportProjectId"] = this.reportProjectId !== undefined ? this.reportProjectId : <any>null;
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        data["rmsMonths"] = this.rmsMonths !== undefined ? this.rmsMonths : <any>null;
        data["rmsPercent"] = this.rmsPercent !== undefined ? this.rmsPercent : <any>null;
        data["workdayMonths"] = this.workdayMonths !== undefined ? this.workdayMonths : <any>null;
        data["workdayPercent"] = this.workdayPercent !== undefined ? this.workdayPercent : <any>null;
        return data;
    }
}

export interface IReportProjectEffortVM {
    id?: number;
    projectEffortId?: number | null;
    reportProjectId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number | null;
    percent?: number | null;
    rmsMonths?: number | null;
    rmsPercent?: number | null;
    workdayMonths?: number | null;
    workdayPercent?: number | null;
}

export class ReportSubProjectMultipleLeadersVM implements IReportSubProjectMultipleLeadersVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    reportProjectId?: number;

    constructor(data?: IReportSubProjectMultipleLeadersVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.reportProjectId = _data["reportProjectId"] !== undefined ? _data["reportProjectId"] : <any>null;
        }
    }

    static fromJS(data: any): ReportSubProjectMultipleLeadersVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSubProjectMultipleLeadersVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["reportProjectId"] = this.reportProjectId !== undefined ? this.reportProjectId : <any>null;
        return data;
    }
}

export interface IReportSubProjectMultipleLeadersVM {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    reportProjectId?: number;
}

export class UpdateProjectResponse implements IUpdateProjectResponse {
    project?: ProjectVM | null;

    constructor(data?: IUpdateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectVM.fromJS(_data["project"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateProjectResponse {
    project?: ProjectVM | null;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    projectVm?: ProjectVM | null;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectVm = _data["projectVm"] ? ProjectVM.fromJS(_data["projectVm"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectVm"] = this.projectVm ? this.projectVm.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateProjectRequest {
    projectVm?: ProjectVM | null;
}

export class RefreshSubProjectsResponse implements IRefreshSubProjectsResponse {
    projectVMs?: ProjectVM[] | null;

    constructor(data?: IRefreshSubProjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectVMs"])) {
                this.projectVMs = [] as any;
                for (let item of _data["projectVMs"])
                    this.projectVMs!.push(ProjectVM.fromJS(item));
            }
            else {
                this.projectVMs = <any>null;
            }
        }
    }

    static fromJS(data: any): RefreshSubProjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshSubProjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectVMs)) {
            data["projectVMs"] = [];
            for (let item of this.projectVMs)
                data["projectVMs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRefreshSubProjectsResponse {
    projectVMs?: ProjectVM[] | null;
}

export class RefreshSubProjectsRequest implements IRefreshSubProjectsRequest {
    projectVMs?: ProjectVM[] | null;

    constructor(data?: IRefreshSubProjectsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectVMs"])) {
                this.projectVMs = [] as any;
                for (let item of _data["projectVMs"])
                    this.projectVMs!.push(ProjectVM.fromJS(item));
            }
            else {
                this.projectVMs = <any>null;
            }
        }
    }

    static fromJS(data: any): RefreshSubProjectsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshSubProjectsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectVMs)) {
            data["projectVMs"] = [];
            for (let item of this.projectVMs)
                data["projectVMs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRefreshSubProjectsRequest {
    projectVMs?: ProjectVM[] | null;
}

export class CreateProjectResponse implements ICreateProjectResponse {
    project?: ProjectVM | null;

    constructor(data?: ICreateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectVM.fromJS(_data["project"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateProjectResponse {
    project?: ProjectVM | null;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    projectVm?: ProjectVM | null;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectVm = _data["projectVm"] ? ProjectVM.fromJS(_data["projectVm"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectVm"] = this.projectVm ? this.projectVm.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateProjectRequest {
    projectVm?: ProjectVM | null;
}

export class DeleteProjectResponse implements IDeleteProjectResponse {
    id?: number;

    constructor(data?: IDeleteProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteProjectResponse {
    id?: number;
}

export class AddRecentActivityResponse implements IAddRecentActivityResponse {
    recentActivity?: RecentActivityVM | null;

    constructor(data?: IAddRecentActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentActivity = _data["recentActivity"] ? RecentActivityVM.fromJS(_data["recentActivity"]) : <any>null;
        }
    }

    static fromJS(data: any): AddRecentActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRecentActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentActivity"] = this.recentActivity ? this.recentActivity.toJSON() : <any>null;
        return data;
    }
}

export interface IAddRecentActivityResponse {
    recentActivity?: RecentActivityVM | null;
}

export class RecentActivityVM implements IRecentActivityVM {
    id?: number;
    type?: string | null;
    userId?: string | null;
    displayText?: string | null;
    displaySubtext?: string | null;
    accessDate?: Date;
    itemId?: number;
    researcherId?: number;

    constructor(data?: IRecentActivityVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
            this.displaySubtext = _data["displaySubtext"] !== undefined ? _data["displaySubtext"] : <any>null;
            this.accessDate = _data["accessDate"] ? new Date(_data["accessDate"].toString()) : <any>null;
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
            this.researcherId = _data["researcherId"] !== undefined ? _data["researcherId"] : <any>null;
        }
    }

    static fromJS(data: any): RecentActivityVM {
        data = typeof data === 'object' ? data : {};
        let result = new RecentActivityVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        data["displaySubtext"] = this.displaySubtext !== undefined ? this.displaySubtext : <any>null;
        data["accessDate"] = this.accessDate ? this.accessDate.toISOString() : <any>null;
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["researcherId"] = this.researcherId !== undefined ? this.researcherId : <any>null;
        return data;
    }
}

export interface IRecentActivityVM {
    id?: number;
    type?: string | null;
    userId?: string | null;
    displayText?: string | null;
    displaySubtext?: string | null;
    accessDate?: Date;
    itemId?: number;
    researcherId?: number;
}

export class AddRecentActivityRequest implements IAddRecentActivityRequest {
    type?: string | null;
    userId?: string | null;
    displayText?: string | null;
    displaySubtext?: string | null;
    accessDate?: Date;
    itemId?: number;
    researcherId?: number;

    constructor(data?: IAddRecentActivityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
            this.displaySubtext = _data["displaySubtext"] !== undefined ? _data["displaySubtext"] : <any>null;
            this.accessDate = _data["accessDate"] ? new Date(_data["accessDate"].toString()) : <any>null;
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
            this.researcherId = _data["researcherId"] !== undefined ? _data["researcherId"] : <any>null;
        }
    }

    static fromJS(data: any): AddRecentActivityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRecentActivityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        data["displaySubtext"] = this.displaySubtext !== undefined ? this.displaySubtext : <any>null;
        data["accessDate"] = this.accessDate ? this.accessDate.toISOString() : <any>null;
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["researcherId"] = this.researcherId !== undefined ? this.researcherId : <any>null;
        return data;
    }
}

export interface IAddRecentActivityRequest {
    type?: string | null;
    userId?: string | null;
    displayText?: string | null;
    displaySubtext?: string | null;
    accessDate?: Date;
    itemId?: number;
    researcherId?: number;
}

export class GetRecentActivitiesResponse implements IGetRecentActivitiesResponse {
    recentActivities?: RecentActivityVM[] | null;

    constructor(data?: IGetRecentActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recentActivities"])) {
                this.recentActivities = [] as any;
                for (let item of _data["recentActivities"])
                    this.recentActivities!.push(RecentActivityVM.fromJS(item));
            }
            else {
                this.recentActivities = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRecentActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recentActivities)) {
            data["recentActivities"] = [];
            for (let item of this.recentActivities)
                data["recentActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentActivitiesResponse {
    recentActivities?: RecentActivityVM[] | null;
}

export class GetRecordHistoryResponse implements IGetRecordHistoryResponse {
    recordHistory?: RecordHistoryVM[] | null;

    constructor(data?: IGetRecordHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recordHistory"])) {
                this.recordHistory = [] as any;
                for (let item of _data["recordHistory"])
                    this.recordHistory!.push(RecordHistoryVM.fromJS(item));
            }
            else {
                this.recordHistory = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRecordHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recordHistory)) {
            data["recordHistory"] = [];
            for (let item of this.recordHistory)
                data["recordHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecordHistoryResponse {
    recordHistory?: RecordHistoryVM[] | null;
}

export class RecordHistoryVM implements IRecordHistoryVM {
    id?: number;
    action?: string | null;
    date?: Date;
    recordId?: number;
    recordType?: string | null;
    userFullName?: string | null;

    constructor(data?: IRecordHistoryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.recordType = _data["recordType"] !== undefined ? _data["recordType"] : <any>null;
            this.userFullName = _data["userFullName"] !== undefined ? _data["userFullName"] : <any>null;
        }
    }

    static fromJS(data: any): RecordHistoryVM {
        data = typeof data === 'object' ? data : {};
        let result = new RecordHistoryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["recordType"] = this.recordType !== undefined ? this.recordType : <any>null;
        data["userFullName"] = this.userFullName !== undefined ? this.userFullName : <any>null;
        return data;
    }
}

export interface IRecordHistoryVM {
    id?: number;
    action?: string | null;
    date?: Date;
    recordId?: number;
    recordType?: string | null;
    userFullName?: string | null;
}

export class CreateReportByPersonResponse implements ICreateReportByPersonResponse {
    report?: ReportVM | null;

    constructor(data?: ICreateReportByPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? ReportVM.fromJS(_data["report"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReportByPersonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportByPersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReportByPersonResponse {
    report?: ReportVM | null;
}

export class ReportVM implements IReportVM {
    id?: number;
    reportPersonId?: number;
    reportPerson?: ReportPersonVM | null;
    title?: string | null;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    notes?: string | null;
    asOfDate?: Date;
    reportInKinds?: ReportInKindVM[] | null;
    reportProjects?: ReportProjectVM[] | null;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    isArchived?: boolean;
    failToGetRmsData?: boolean;

    constructor(data?: IReportVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportPerson = _data["reportPerson"] ? ReportPersonVM.fromJS(_data["reportPerson"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isFinalized = _data["isFinalized"] !== undefined ? _data["isFinalized"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKinds"])) {
                this.reportInKinds = [] as any;
                for (let item of _data["reportInKinds"])
                    this.reportInKinds!.push(ReportInKindVM.fromJS(item));
            }
            else {
                this.reportInKinds = <any>null;
            }
            if (Array.isArray(_data["reportProjects"])) {
                this.reportProjects = [] as any;
                for (let item of _data["reportProjects"])
                    this.reportProjects!.push(ReportProjectVM.fromJS(item));
            }
            else {
                this.reportProjects = <any>null;
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.failToGetRmsData = _data["failToGetRmsData"] !== undefined ? _data["failToGetRmsData"] : <any>null;
        }
    }

    static fromJS(data: any): ReportVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportPerson"] = this.reportPerson ? this.reportPerson.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isFinalized"] = this.isFinalized !== undefined ? this.isFinalized : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKinds)) {
            data["reportInKinds"] = [];
            for (let item of this.reportInKinds)
                data["reportInKinds"].push(item.toJSON());
        }
        if (Array.isArray(this.reportProjects)) {
            data["reportProjects"] = [];
            for (let item of this.reportProjects)
                data["reportProjects"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["failToGetRmsData"] = this.failToGetRmsData !== undefined ? this.failToGetRmsData : <any>null;
        return data;
    }
}

export interface IReportVM {
    id?: number;
    reportPersonId?: number;
    reportPerson?: ReportPersonVM | null;
    title?: string | null;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    notes?: string | null;
    asOfDate?: Date;
    reportInKinds?: ReportInKindVM[] | null;
    reportProjects?: ReportProjectVM[] | null;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    isArchived?: boolean;
    failToGetRmsData?: boolean;
}

export class ReportPersonVM implements IReportPersonVM {
    id?: number;
    reportId?: number;
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    isDeleted?: boolean | null;

    constructor(data?: IReportPersonVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.wustlEduId = _data["wustlEduId"] !== undefined ? _data["wustlEduId"] : <any>null;
            this.commonsID = _data["commonsID"] !== undefined ? _data["commonsID"] : <any>null;
            this.orcid = _data["orcid"] !== undefined ? _data["orcid"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.costCenterHierarchy = _data["costCenterHierarchy"] !== undefined ? _data["costCenterHierarchy"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): ReportPersonVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPersonVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["wustlEduId"] = this.wustlEduId !== undefined ? this.wustlEduId : <any>null;
        data["commonsID"] = this.commonsID !== undefined ? this.commonsID : <any>null;
        data["orcid"] = this.orcid !== undefined ? this.orcid : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["costCenterHierarchy"] = this.costCenterHierarchy !== undefined ? this.costCenterHierarchy : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }
}

export interface IReportPersonVM {
    id?: number;
    reportId?: number;
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    isDeleted?: boolean | null;
}

export class ReportInKindVM implements IReportInKindVM {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;
    updateUserId?: string | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;

    constructor(data?: IReportInKindVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKindEfforts"])) {
                this.reportInKindEfforts = [] as any;
                for (let item of _data["reportInKindEfforts"])
                    this.reportInKindEfforts!.push(ReportInKindEffortVM.fromJS(item));
            }
            else {
                this.reportInKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
        }
    }

    static fromJS(data: any): ReportInKindVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInKindVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKindEfforts)) {
            data["reportInKindEfforts"] = [];
            for (let item of this.reportInKindEfforts)
                data["reportInKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        return data;
    }
}

export interface IReportInKindVM {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;
    updateUserId?: string | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
}

export class ReportInKindEffortVM implements IReportInKindEffortVM {
    id?: number;
    inKindEffortId?: number | null;
    reportInKindId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number | null;
    percent?: number | null;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;
    updateUserId?: string | null;

    constructor(data?: IReportInKindEffortVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindEffortId = _data["inKindEffortId"] !== undefined ? _data["inKindEffortId"] : <any>null;
            this.reportInKindId = _data["reportInKindId"] !== undefined ? _data["reportInKindId"] : <any>null;
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
        }
    }

    static fromJS(data: any): ReportInKindEffortVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInKindEffortVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindEffortId"] = this.inKindEffortId !== undefined ? this.inKindEffortId : <any>null;
        data["reportInKindId"] = this.reportInKindId !== undefined ? this.reportInKindId : <any>null;
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        return data;
    }
}

export interface IReportInKindEffortVM {
    id?: number;
    inKindEffortId?: number | null;
    reportInKindId?: number;
    yearSequence?: string | null;
    year?: number;
    months?: number | null;
    percent?: number | null;
    createdDate?: Date | null;
    lastUpdatedDate?: Date | null;
    updateUserId?: string | null;
}

export class CreateReportByPersonRequest implements ICreateReportByPersonRequest {
    personId?: number;
    asOfDate?: Date;
    title?: string | null;

    constructor(data?: ICreateReportByPersonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateReportByPersonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportByPersonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface ICreateReportByPersonRequest {
    personId?: number;
    asOfDate?: Date;
    title?: string | null;
}

export class CopyReportByReportIdResponse implements ICopyReportByReportIdResponse {
    report?: ReportVM | null;

    constructor(data?: ICopyReportByReportIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? ReportVM.fromJS(_data["report"]) : <any>null;
        }
    }

    static fromJS(data: any): CopyReportByReportIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyReportByReportIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : <any>null;
        return data;
    }
}

export interface ICopyReportByReportIdResponse {
    report?: ReportVM | null;
}

export class CopyReportByReportIdRequest implements ICopyReportByReportIdRequest {
    reportId?: number;
    asOfDate?: Date;
    title?: string | null;

    constructor(data?: ICopyReportByReportIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CopyReportByReportIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyReportByReportIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface ICopyReportByReportIdRequest {
    reportId?: number;
    asOfDate?: Date;
    title?: string | null;
}

export class GetReportsByPersonIdResponse implements IGetReportsByPersonIdResponse {
    reports?: ReportVM[] | null;

    constructor(data?: IGetReportsByPersonIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReportVM.fromJS(item));
            }
            else {
                this.reports = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportsByPersonIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportsByPersonIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportsByPersonIdResponse {
    reports?: ReportVM[] | null;
}

export class GetReportsOutForReviewResponse implements IGetReportsOutForReviewResponse {
    reports?: ReportVM[] | null;

    constructor(data?: IGetReportsOutForReviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ReportVM.fromJS(item));
            }
            else {
                this.reports = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportsOutForReviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportsOutForReviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportsOutForReviewResponse {
    reports?: ReportVM[] | null;
}

export class GetReportHeadersByPersonIdResponse implements IGetReportHeadersByPersonIdResponse {
    reportHeaders?: ReportHeaderVM[] | null;

    constructor(data?: IGetReportHeadersByPersonIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportHeaders"])) {
                this.reportHeaders = [] as any;
                for (let item of _data["reportHeaders"])
                    this.reportHeaders!.push(ReportHeaderVM.fromJS(item));
            }
            else {
                this.reportHeaders = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportHeadersByPersonIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportHeadersByPersonIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportHeaders)) {
            data["reportHeaders"] = [];
            for (let item of this.reportHeaders)
                data["reportHeaders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportHeadersByPersonIdResponse {
    reportHeaders?: ReportHeaderVM[] | null;
}

export class ReportHeaderVM implements IReportHeaderVM {
    id?: number;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    asOfDate?: Date;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    title?: string | null;

    constructor(data?: IReportHeaderVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isFinalized = _data["isFinalized"] !== undefined ? _data["isFinalized"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ReportHeaderVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportHeaderVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isFinalized"] = this.isFinalized !== undefined ? this.isFinalized : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IReportHeaderVM {
    id?: number;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    asOfDate?: Date;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
    title?: string | null;
}

export class GetReportByIdResponse implements IGetReportByIdResponse {
    report?: ReportVM | null;

    constructor(data?: IGetReportByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? ReportVM.fromJS(_data["report"]) : <any>null;
        }
    }

    static fromJS(data: any): GetReportByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : <any>null;
        return data;
    }
}

export interface IGetReportByIdResponse {
    report?: ReportVM | null;
}

export class UpdateReportResponse implements IUpdateReportResponse {
    report?: ReportVM | null;

    constructor(data?: IUpdateReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report = _data["report"] ? ReportVM.fromJS(_data["report"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateReportResponse {
    report?: ReportVM | null;
}

export class UpdateReportRequest implements IUpdateReportRequest {
    id?: number;
    reportPersonId?: number;
    reportPerson?: ReportPersonVM | null;
    title?: string | null;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    notes?: string | null;
    asOfDate?: Date;
    reportInKinds?: ReportInKindVM[] | null;
    reportProjects?: ReportProjectVM[] | null;
    isArchived?: boolean;

    constructor(data?: IUpdateReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportPerson = _data["reportPerson"] ? ReportPersonVM.fromJS(_data["reportPerson"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.isFinalized = _data["isFinalized"] !== undefined ? _data["isFinalized"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKinds"])) {
                this.reportInKinds = [] as any;
                for (let item of _data["reportInKinds"])
                    this.reportInKinds!.push(ReportInKindVM.fromJS(item));
            }
            else {
                this.reportInKinds = <any>null;
            }
            if (Array.isArray(_data["reportProjects"])) {
                this.reportProjects = [] as any;
                for (let item of _data["reportProjects"])
                    this.reportProjects!.push(ReportProjectVM.fromJS(item));
            }
            else {
                this.reportProjects = <any>null;
            }
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportPerson"] = this.reportPerson ? this.reportPerson.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isFinalized"] = this.isFinalized !== undefined ? this.isFinalized : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKinds)) {
            data["reportInKinds"] = [];
            for (let item of this.reportInKinds)
                data["reportInKinds"].push(item.toJSON());
        }
        if (Array.isArray(this.reportProjects)) {
            data["reportProjects"] = [];
            for (let item of this.reportProjects)
                data["reportProjects"].push(item.toJSON());
        }
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        return data;
    }
}

export interface IUpdateReportRequest {
    id?: number;
    reportPersonId?: number;
    reportPerson?: ReportPersonVM | null;
    title?: string | null;
    isFinalized?: boolean;
    status?: string | null;
    overlap?: string | null;
    notes?: string | null;
    asOfDate?: Date;
    reportInKinds?: ReportInKindVM[] | null;
    reportProjects?: ReportProjectVM[] | null;
    isArchived?: boolean;
}

export class DeleteReportResponse implements IDeleteReportResponse {
    id?: number;

    constructor(data?: IDeleteReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteReportResponse {
    id?: number;
}

export class GetReportPersonByIdResponse implements IGetReportPersonByIdResponse {
    reportPerson?: ReportPersonVM | null;

    constructor(data?: IGetReportPersonByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportPerson = _data["reportPerson"] ? ReportPersonVM.fromJS(_data["reportPerson"]) : <any>null;
        }
    }

    static fromJS(data: any): GetReportPersonByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportPersonByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportPerson"] = this.reportPerson ? this.reportPerson.toJSON() : <any>null;
        return data;
    }
}

export interface IGetReportPersonByIdResponse {
    reportPerson?: ReportPersonVM | null;
}

export class ExportReportRequest implements IExportReportRequest {
    id?: number;

    constructor(data?: IExportReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ExportReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IExportReportRequest {
    id?: number;
}

export class ExportCommonFormReportRequest implements IExportCommonFormReportRequest {
    id?: number;

    constructor(data?: IExportCommonFormReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ExportCommonFormReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCommonFormReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IExportCommonFormReportRequest {
    id?: number;
}

export class ExportReportDocxRequest implements IExportReportDocxRequest {
    id?: number;
    withEverything?: boolean;

    constructor(data?: IExportReportDocxRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.withEverything = _data["withEverything"] !== undefined ? _data["withEverything"] : <any>null;
        }
    }

    static fromJS(data: any): ExportReportDocxRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportReportDocxRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["withEverything"] = this.withEverything !== undefined ? this.withEverything : <any>null;
        return data;
    }
}

export interface IExportReportDocxRequest {
    id?: number;
    withEverything?: boolean;
}

export class ExportCommonFormReportDocxRequest implements IExportCommonFormReportDocxRequest {
    id?: number;
    withEverything?: boolean;

    constructor(data?: IExportCommonFormReportDocxRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.withEverything = _data["withEverything"] !== undefined ? _data["withEverything"] : <any>null;
        }
    }

    static fromJS(data: any): ExportCommonFormReportDocxRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCommonFormReportDocxRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["withEverything"] = this.withEverything !== undefined ? this.withEverything : <any>null;
        return data;
    }
}

export interface IExportCommonFormReportDocxRequest {
    id?: number;
    withEverything?: boolean;
}

export class ExportXmlRequest implements IExportXmlRequest {
    id?: number;

    constructor(data?: IExportXmlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ExportXmlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportXmlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IExportXmlRequest {
    id?: number;
}

export class GetReportInKindsResponse implements IGetReportInKindsResponse {
    reportInKinds?: ReportInKindVM[] | null;

    constructor(data?: IGetReportInKindsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportInKinds"])) {
                this.reportInKinds = [] as any;
                for (let item of _data["reportInKinds"])
                    this.reportInKinds!.push(ReportInKindVM.fromJS(item));
            }
            else {
                this.reportInKinds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportInKindsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportInKindsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportInKinds)) {
            data["reportInKinds"] = [];
            for (let item of this.reportInKinds)
                data["reportInKinds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportInKindsResponse {
    reportInKinds?: ReportInKindVM[] | null;
}

export class CreateReportInKindResponse implements ICreateReportInKindResponse {
    reportInKind?: ReportInKindVM | null;

    constructor(data?: ICreateReportInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportInKind = _data["reportInKind"] ? ReportInKindVM.fromJS(_data["reportInKind"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReportInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportInKind"] = this.reportInKind ? this.reportInKind.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReportInKindResponse {
    reportInKind?: ReportInKindVM | null;
}

export class CreateReportInKindRequest implements ICreateReportInKindRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;

    constructor(data?: ICreateReportInKindRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKindEfforts"])) {
                this.reportInKindEfforts = [] as any;
                for (let item of _data["reportInKindEfforts"])
                    this.reportInKindEfforts!.push(ReportInKindEffortVM.fromJS(item));
            }
            else {
                this.reportInKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
        }
    }

    static fromJS(data: any): CreateReportInKindRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportInKindRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKindEfforts)) {
            data["reportInKindEfforts"] = [];
            for (let item of this.reportInKindEfforts)
                data["reportInKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        return data;
    }
}

export interface ICreateReportInKindRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;
}

export class UpdateReportInKindResponse implements IUpdateReportInKindResponse {
    reportInKind?: ReportInKindVM | null;

    constructor(data?: IUpdateReportInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportInKind = _data["reportInKind"] ? ReportInKindVM.fromJS(_data["reportInKind"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportInKind"] = this.reportInKind ? this.reportInKind.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateReportInKindResponse {
    reportInKind?: ReportInKindVM | null;
}

export class UpdateReportInKindRequest implements IUpdateReportInKindRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;

    constructor(data?: IUpdateReportInKindRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKindEfforts"])) {
                this.reportInKindEfforts = [] as any;
                for (let item of _data["reportInKindEfforts"])
                    this.reportInKindEfforts!.push(ReportInKindEffortVM.fromJS(item));
            }
            else {
                this.reportInKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportInKindRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportInKindRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKindEfforts)) {
            data["reportInKindEfforts"] = [];
            for (let item of this.reportInKindEfforts)
                data["reportInKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        return data;
    }
}

export interface IUpdateReportInKindRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;
}

export class SaveToMasterInKindListResponse implements ISaveToMasterInKindListResponse {
    inKind?: InKindVM | null;

    constructor(data?: ISaveToMasterInKindListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inKind = _data["inKind"] ? InKindVM.fromJS(_data["inKind"]) : <any>null;
        }
    }

    static fromJS(data: any): SaveToMasterInKindListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveToMasterInKindListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inKind"] = this.inKind ? this.inKind.toJSON() : <any>null;
        return data;
    }
}

export interface ISaveToMasterInKindListResponse {
    inKind?: InKindVM | null;
}

export class SaveToMasterInKindListRequest implements ISaveToMasterInKindListRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;

    constructor(data?: ISaveToMasterInKindListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.reportPersonId = _data["reportPersonId"] !== undefined ? _data["reportPersonId"] : <any>null;
            this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["reportInKindEfforts"])) {
                this.reportInKindEfforts = [] as any;
                for (let item of _data["reportInKindEfforts"])
                    this.reportInKindEfforts!.push(ReportInKindEffortVM.fromJS(item));
            }
            else {
                this.reportInKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
        }
    }

    static fromJS(data: any): SaveToMasterInKindListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveToMasterInKindListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["reportPersonId"] = this.reportPersonId !== undefined ? this.reportPersonId : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.reportInKindEfforts)) {
            data["reportInKindEfforts"] = [];
            for (let item of this.reportInKindEfforts)
                data["reportInKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        return data;
    }
}

export interface ISaveToMasterInKindListRequest {
    id?: number;
    inKindId?: number | null;
    reportPersonId?: number;
    reportId?: number;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    reportInKindEfforts?: ReportInKindEffortVM[] | null;
    estimatedDollarValue?: number;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overlap?: string | null;
    sourceOfSupport?: string | null;
    overallObjectives?: string | null;
}

export class SaveArrToMasterInKindListResponse implements ISaveArrToMasterInKindListResponse {
    inKinds?: InKindVM[] | null;

    constructor(data?: ISaveArrToMasterInKindListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inKinds"])) {
                this.inKinds = [] as any;
                for (let item of _data["inKinds"])
                    this.inKinds!.push(InKindVM.fromJS(item));
            }
            else {
                this.inKinds = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveArrToMasterInKindListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveArrToMasterInKindListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inKinds)) {
            data["inKinds"] = [];
            for (let item of this.inKinds)
                data["inKinds"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveArrToMasterInKindListResponse {
    inKinds?: InKindVM[] | null;
}

export class SaveArrToMasterInKindListRequest implements ISaveArrToMasterInKindListRequest {
    reportInKindsToSaveToMaster?: ReportInKindVM[] | null;

    constructor(data?: ISaveArrToMasterInKindListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportInKindsToSaveToMaster"])) {
                this.reportInKindsToSaveToMaster = [] as any;
                for (let item of _data["reportInKindsToSaveToMaster"])
                    this.reportInKindsToSaveToMaster!.push(ReportInKindVM.fromJS(item));
            }
            else {
                this.reportInKindsToSaveToMaster = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveArrToMasterInKindListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveArrToMasterInKindListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportInKindsToSaveToMaster)) {
            data["reportInKindsToSaveToMaster"] = [];
            for (let item of this.reportInKindsToSaveToMaster)
                data["reportInKindsToSaveToMaster"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveArrToMasterInKindListRequest {
    reportInKindsToSaveToMaster?: ReportInKindVM[] | null;
}

export class DeleteReportInKindResponse implements IDeleteReportInKindResponse {
    id?: number;

    constructor(data?: IDeleteReportInKindResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteReportInKindResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportInKindResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteReportInKindResponse {
    id?: number;
}

export class DeleteReportInKindArrResponse implements IDeleteReportInKindArrResponse {
    ids?: number[] | null;

    constructor(data?: IDeleteReportInKindArrResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteReportInKindArrResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportInKindArrResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteReportInKindArrResponse {
    ids?: number[] | null;
}

export class GetReportProjectsResponse implements IGetReportProjectsResponse {
    reportProjects?: ReportProjectVM[] | null;

    constructor(data?: IGetReportProjectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportProjects"])) {
                this.reportProjects = [] as any;
                for (let item of _data["reportProjects"])
                    this.reportProjects!.push(ReportProjectVM.fromJS(item));
            }
            else {
                this.reportProjects = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReportProjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportProjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportProjects)) {
            data["reportProjects"] = [];
            for (let item of this.reportProjects)
                data["reportProjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportProjectsResponse {
    reportProjects?: ReportProjectVM[] | null;
}

export class GetActiveProjectsTotalPercentResponse implements IGetActiveProjectsTotalPercentResponse {
    totalPercent?: number;

    constructor(data?: IGetActiveProjectsTotalPercentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPercent = _data["totalPercent"] !== undefined ? _data["totalPercent"] : <any>null;
        }
    }

    static fromJS(data: any): GetActiveProjectsTotalPercentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveProjectsTotalPercentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPercent"] = this.totalPercent !== undefined ? this.totalPercent : <any>null;
        return data;
    }
}

export interface IGetActiveProjectsTotalPercentResponse {
    totalPercent?: number;
}

export class GetReportProjectByRMSProjectNumResponse implements IGetReportProjectByRMSProjectNumResponse {
    projectId?: number;

    constructor(data?: IGetReportProjectByRMSProjectNumResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
        }
    }

    static fromJS(data: any): GetReportProjectByRMSProjectNumResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportProjectByRMSProjectNumResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        return data;
    }
}

export interface IGetReportProjectByRMSProjectNumResponse {
    projectId?: number;
}

export class GetReportProjectByIdResponse implements IGetReportProjectByIdResponse {
    reportProject?: ReportProjectVM | null;

    constructor(data?: IGetReportProjectByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProject = _data["reportProject"] ? ReportProjectVM.fromJS(_data["reportProject"]) : <any>null;
        }
    }

    static fromJS(data: any): GetReportProjectByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportProjectByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProject"] = this.reportProject ? this.reportProject.toJSON() : <any>null;
        return data;
    }
}

export interface IGetReportProjectByIdResponse {
    reportProject?: ReportProjectVM | null;
}

export class CreateReportProjectResponse implements ICreateReportProjectResponse {
    reportProject?: ReportProjectVM | null;

    constructor(data?: ICreateReportProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProject = _data["reportProject"] ? ReportProjectVM.fromJS(_data["reportProject"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReportProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProject"] = this.reportProject ? this.reportProject.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReportProjectResponse {
    reportProject?: ReportProjectVM | null;
}

export class CreateReportProjectRequest implements ICreateReportProjectRequest {
    reportProjectVm?: ReportProjectVM | null;

    constructor(data?: ICreateReportProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProjectVm = _data["reportProjectVm"] ? ReportProjectVM.fromJS(_data["reportProjectVm"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReportProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProjectVm"] = this.reportProjectVm ? this.reportProjectVm.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReportProjectRequest {
    reportProjectVm?: ReportProjectVM | null;
}

export class UpdateReportProjectResponse implements IUpdateReportProjectResponse {
    reportProject?: ReportProjectVM | null;

    constructor(data?: IUpdateReportProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProject = _data["reportProject"] ? ReportProjectVM.fromJS(_data["reportProject"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProject"] = this.reportProject ? this.reportProject.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateReportProjectResponse {
    reportProject?: ReportProjectVM | null;
}

export class UpdateReportProjectRequest implements IUpdateReportProjectRequest {
    reportProjectVm?: ReportProjectVM | null;

    constructor(data?: IUpdateReportProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProjectVm = _data["reportProjectVm"] ? ReportProjectVM.fromJS(_data["reportProjectVm"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProjectVm"] = this.reportProjectVm ? this.reportProjectVm.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateReportProjectRequest {
    reportProjectVm?: ReportProjectVM | null;
}

export class DeleteReportProjectResponse implements IDeleteReportProjectResponse {
    id?: number;

    constructor(data?: IDeleteReportProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteReportProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteReportProjectResponse {
    id?: number;
}

export class RefreshProject implements IRefreshProject {
    reportProjectId?: number;

    constructor(data?: IRefreshProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportProjectId = _data["reportProjectId"] !== undefined ? _data["reportProjectId"] : <any>null;
        }
    }

    static fromJS(data: any): RefreshProject {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportProjectId"] = this.reportProjectId !== undefined ? this.reportProjectId : <any>null;
        return data;
    }
}

export interface IRefreshProject {
    reportProjectId?: number;
}

export class DeleteReportProjectArrResponse implements IDeleteReportProjectArrResponse {
    ids?: number[] | null;

    constructor(data?: IDeleteReportProjectArrResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteReportProjectArrResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportProjectArrResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteReportProjectArrResponse {
    ids?: number[] | null;
}

export class CreateReportTemplateResponse implements ICreateReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;

    constructor(data?: ICreateReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateVM.fromJS(_data["reportTemplate"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;
}

export class ReportTemplateVM implements IReportTemplateVM {
    id?: number;
    header?: string | null;
    footer?: string | null;
    title?: string | null;
    signatureText?: string | null;
    type?: string | null;

    constructor(data?: IReportTemplateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.footer = _data["footer"] !== undefined ? _data["footer"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.signatureText = _data["signatureText"] !== undefined ? _data["signatureText"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ReportTemplateVM {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTemplateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["footer"] = this.footer !== undefined ? this.footer : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["signatureText"] = this.signatureText !== undefined ? this.signatureText : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IReportTemplateVM {
    id?: number;
    header?: string | null;
    footer?: string | null;
    title?: string | null;
    signatureText?: string | null;
    type?: string | null;
}

export class CreateReportTemplateRequest implements ICreateReportTemplateRequest {
    title?: string | null;
    header?: string | null;
    footer?: string | null;
    signatureText?: string | null;
    type?: string | null;

    constructor(data?: ICreateReportTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.footer = _data["footer"] !== undefined ? _data["footer"] : <any>null;
            this.signatureText = _data["signatureText"] !== undefined ? _data["signatureText"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): CreateReportTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["footer"] = this.footer !== undefined ? this.footer : <any>null;
        data["signatureText"] = this.signatureText !== undefined ? this.signatureText : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface ICreateReportTemplateRequest {
    title?: string | null;
    header?: string | null;
    footer?: string | null;
    signatureText?: string | null;
    type?: string | null;
}

export class GetReportTemplateResponse implements IGetReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;

    constructor(data?: IGetReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateVM.fromJS(_data["reportTemplate"]) : <any>null;
        }
    }

    static fromJS(data: any): GetReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>null;
        return data;
    }
}

export interface IGetReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;
}

export class GetAllReportTemplatesResponse implements IGetAllReportTemplatesResponse {
    reportTemplates?: ReportTemplateVM[] | null;

    constructor(data?: IGetAllReportTemplatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportTemplates"])) {
                this.reportTemplates = [] as any;
                for (let item of _data["reportTemplates"])
                    this.reportTemplates!.push(ReportTemplateVM.fromJS(item));
            }
            else {
                this.reportTemplates = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllReportTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportTemplates)) {
            data["reportTemplates"] = [];
            for (let item of this.reportTemplates)
                data["reportTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllReportTemplatesResponse {
    reportTemplates?: ReportTemplateVM[] | null;
}

export class GetAllReportTemplatesRequest implements IGetAllReportTemplatesRequest {

    constructor(data?: IGetAllReportTemplatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllReportTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportTemplatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllReportTemplatesRequest {
}

export class UpdateReportTemplateResponse implements IUpdateReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;

    constructor(data?: IUpdateReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTemplate = _data["reportTemplate"] ? ReportTemplateVM.fromJS(_data["reportTemplate"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTemplate"] = this.reportTemplate ? this.reportTemplate.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateReportTemplateResponse {
    reportTemplate?: ReportTemplateVM | null;
}

export class UpdateReportTemplateRequest implements IUpdateReportTemplateRequest {
    id?: number;
    title?: string | null;
    header?: string | null;
    footer?: string | null;
    signatureText?: string | null;
    type?: string | null;

    constructor(data?: IUpdateReportTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.header = _data["header"] !== undefined ? _data["header"] : <any>null;
            this.footer = _data["footer"] !== undefined ? _data["footer"] : <any>null;
            this.signatureText = _data["signatureText"] !== undefined ? _data["signatureText"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["footer"] = this.footer !== undefined ? this.footer : <any>null;
        data["signatureText"] = this.signatureText !== undefined ? this.signatureText : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IUpdateReportTemplateRequest {
    id?: number;
    title?: string | null;
    header?: string | null;
    footer?: string | null;
    signatureText?: string | null;
    type?: string | null;
}

export class DeleteReportTemplateResponse implements IDeleteReportTemplateResponse {
    isDeleted?: boolean;

    constructor(data?: IDeleteReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }
}

export interface IDeleteReportTemplateResponse {
    isDeleted?: boolean;
}

export class GetUserCostCentersResponse implements IGetUserCostCentersResponse {
    userCostCenterVMs?: UserCostCenterVM[] | null;

    constructor(data?: IGetUserCostCentersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userCostCenterVMs"])) {
                this.userCostCenterVMs = [] as any;
                for (let item of _data["userCostCenterVMs"])
                    this.userCostCenterVMs!.push(UserCostCenterVM.fromJS(item));
            }
            else {
                this.userCostCenterVMs = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUserCostCentersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserCostCentersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userCostCenterVMs)) {
            data["userCostCenterVMs"] = [];
            for (let item of this.userCostCenterVMs)
                data["userCostCenterVMs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserCostCentersResponse {
    userCostCenterVMs?: UserCostCenterVM[] | null;
}

export class UserCostCenterVM implements IUserCostCenterVM {
    externalId?: string | null;
    costCenter?: string | null;
    name?: string | null;
    isRms?: boolean;

    constructor(data?: IUserCostCenterVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isRms = _data["isRms"] !== undefined ? _data["isRms"] : <any>null;
        }
    }

    static fromJS(data: any): UserCostCenterVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserCostCenterVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isRms"] = this.isRms !== undefined ? this.isRms : <any>null;
        return data;
    }
}

export interface IUserCostCenterVM {
    externalId?: string | null;
    costCenter?: string | null;
    name?: string | null;
    isRms?: boolean;
}

export class AddRadarUserCostCenter implements IAddRadarUserCostCenter {
    externalId?: string | null;
    costCenter?: string | null;

    constructor(data?: IAddRadarUserCostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
        }
    }

    static fromJS(data: any): AddRadarUserCostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new AddRadarUserCostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        return data;
    }
}

export interface IAddRadarUserCostCenter {
    externalId?: string | null;
    costCenter?: string | null;
}

export class RemoveRadarUserCostCenter implements IRemoveRadarUserCostCenter {
    externalId?: string | null;
    costCenter?: string | null;

    constructor(data?: IRemoveRadarUserCostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveRadarUserCostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveRadarUserCostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : <any>null;
        return data;
    }
}

export interface IRemoveRadarUserCostCenter {
    externalId?: string | null;
    costCenter?: string | null;
}

export class UpdateCostCentersFromUserRequestResponse implements IUpdateCostCentersFromUserRequestResponse {
    rmsCount?: number;
    matchingCount?: number;

    constructor(data?: IUpdateCostCentersFromUserRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rmsCount = _data["rmsCount"] !== undefined ? _data["rmsCount"] : <any>null;
            this.matchingCount = _data["matchingCount"] !== undefined ? _data["matchingCount"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCostCentersFromUserRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostCentersFromUserRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rmsCount"] = this.rmsCount !== undefined ? this.rmsCount : <any>null;
        data["matchingCount"] = this.matchingCount !== undefined ? this.matchingCount : <any>null;
        return data;
    }
}

export interface IUpdateCostCentersFromUserRequestResponse {
    rmsCount?: number;
    matchingCount?: number;
}

export class Feature implements IFeature {
    name?: string | null;
    isEnabled?: boolean;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isEnabled = _data["isEnabled"] !== undefined ? _data["isEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        return data;
    }
}

export interface IFeature {
    name?: string | null;
    isEnabled?: boolean;
}

export class SendEmailResponse implements ISendEmailResponse {

    constructor(data?: ISendEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendEmailResponse {
}

export class SendEmailRequest implements ISendEmailRequest {
    to?: string | null;
    subject?: string | null;
    body?: string | null;

    constructor(data?: ISendEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
        }
    }

    static fromJS(data: any): SendEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to !== undefined ? this.to : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        return data;
    }
}

export interface ISendEmailRequest {
    to?: string | null;
    subject?: string | null;
    body?: string | null;
}

export class GetEmployeesResponse implements IGetEmployeesResponse {
    employees?: Employee[] | null;

    constructor(data?: IGetEmployeesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(Employee.fromJS(item));
            }
            else {
                this.employees = <any>null;
            }
        }
    }

    static fromJS(data: any): GetEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeesResponse {
    employees?: Employee[] | null;
}

export class Employee implements IEmployee {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IEmployee {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class GetRolesResponse implements IGetRolesResponse {
    roles?: RoleViewModel[] | null;

    constructor(data?: IGetRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleViewModel.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRolesResponse {
    roles?: RoleViewModel[] | null;
}

export class RoleViewModel implements IRoleViewModel {
    id?: number | null;
    name?: string | null;
    permissionKeys?: string[] | null;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["permissionKeys"])) {
                this.permissionKeys = [] as any;
                for (let item of _data["permissionKeys"])
                    this.permissionKeys!.push(item);
            }
            else {
                this.permissionKeys = <any>null;
            }
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.permissionKeys)) {
            data["permissionKeys"] = [];
            for (let item of this.permissionKeys)
                data["permissionKeys"].push(item);
        }
        return data;
    }
}

export interface IRoleViewModel {
    id?: number | null;
    name?: string | null;
    permissionKeys?: string[] | null;
}

export class UpdateUserFromTokenRequest implements IUpdateUserFromTokenRequest {
    externalUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IUpdateUserFromTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalUserId = _data["externalUserId"] !== undefined ? _data["externalUserId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserFromTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserFromTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalUserId"] = this.externalUserId !== undefined ? this.externalUserId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IUpdateUserFromTokenRequest {
    externalUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class GetUserResponse implements IGetUserResponse {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
    permissions?: string[] | null;
    mulesoftError?: boolean;

    constructor(data?: IGetUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = <any>null;
            }
            this.mulesoftError = _data["mulesoftError"] !== undefined ? _data["mulesoftError"] : <any>null;
        }
    }

    static fromJS(data: any): GetUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["mulesoftError"] = this.mulesoftError !== undefined ? this.mulesoftError : <any>null;
        return data;
    }
}

export interface IGetUserResponse {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
    permissions?: string[] | null;
    mulesoftError?: boolean;
}

export class IsUserInGroupResponse implements IIsUserInGroupResponse {
    userInGroup?: boolean;

    constructor(data?: IIsUserInGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInGroup = _data["userInGroup"] !== undefined ? _data["userInGroup"] : <any>null;
        }
    }

    static fromJS(data: any): IsUserInGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsUserInGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInGroup"] = this.userInGroup !== undefined ? this.userInGroup : <any>null;
        return data;
    }
}

export interface IIsUserInGroupResponse {
    userInGroup?: boolean;
}

export class GetAllUsersResponse implements IGetAllUsersResponse {
    users?: AppUserViewModel[] | null;

    constructor(data?: IGetAllUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUserViewModel.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllUsersResponse {
    users?: AppUserViewModel[] | null;
}

export class AppUserViewModel implements IAppUserViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;

    constructor(data?: IAppUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AppUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IAppUserViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
}

export class UpdateUserRoleAndStatusResponse implements IUpdateUserRoleAndStatusResponse {

    constructor(data?: IUpdateUserRoleAndStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateUserRoleAndStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleAndStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateUserRoleAndStatusResponse {
}

export class UpdateUserRoleAndStatusRequest implements IUpdateUserRoleAndStatusRequest {
    users?: UpdateUserModel[] | null;

    constructor(data?: IUpdateUserRoleAndStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UpdateUserModel.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateUserRoleAndStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleAndStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateUserRoleAndStatusRequest {
    users?: UpdateUserModel[] | null;
}

export class UpdateUserModel implements IUpdateUserModel {
    id?: number;
    role?: string | null;
    isActive?: boolean;

    constructor(data?: IUpdateUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IUpdateUserModel {
    id?: number;
    role?: string | null;
    isActive?: boolean;
}

export class AddUserResponse implements IAddUserResponse {
    appUser?: AppUserViewModel | null;

    constructor(data?: IAddUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>null;
        }
    }

    static fromJS(data: any): AddUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>null;
        return data;
    }
}

export interface IAddUserResponse {
    appUser?: AppUserViewModel | null;
}

export class AddUserRequest implements IAddUserRequest {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    role?: string | null;

    constructor(data?: IAddUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
        }
    }

    static fromJS(data: any): AddUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        return data;
    }
}

export interface IAddUserRequest {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    role?: string | null;
}

export class GetUtilitiesResponse implements IGetUtilitiesResponse {
    utilities?: UtilityViewModel[] | null;

    constructor(data?: IGetUtilitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(UtilityViewModel.fromJS(item));
            }
            else {
                this.utilities = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUtilitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtilitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUtilitiesResponse {
    utilities?: UtilityViewModel[] | null;
}

export class UtilityViewModel implements IUtilityViewModel {
    id?: number;
    key?: string | null;
    value?: string | null;
    discriminator?: string | null;

    constructor(data?: IUtilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.discriminator = _data["discriminator"] !== undefined ? _data["discriminator"] : <any>null;
        }
    }

    static fromJS(data: any): UtilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : <any>null;
        return data;
    }
}

export interface IUtilityViewModel {
    id?: number;
    key?: string | null;
    value?: string | null;
    discriminator?: string | null;
}

export enum UtilityTables {
    DashboardMessage = "DashboardMessage",
    DashboardTask = "DashboardTask",
    Permission = "Permission",
    Role = "Role",
}

export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc",
}

export class CreateUtilityResponse implements ICreateUtilityResponse {
    id?: number;

    constructor(data?: ICreateUtilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUtilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ICreateUtilityResponse {
    id?: number;
}

export class CreateUtilityRequest implements ICreateUtilityRequest {
    discriminator?: UtilityTables;
    key?: string | null;
    value?: string | null;

    constructor(data?: ICreateUtilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"] !== undefined ? _data["discriminator"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUtilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ICreateUtilityRequest {
    discriminator?: UtilityTables;
    key?: string | null;
    value?: string | null;
}

export class UpdateUtilityResponse implements IUpdateUtilityResponse {

    constructor(data?: IUpdateUtilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateUtilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpdateUtilityResponse {
}

export class UpdateUtilityRequest implements IUpdateUtilityRequest {
    id?: number;
    discriminator?: UtilityTables;
    key?: string | null;
    value?: string | null;

    constructor(data?: IUpdateUtilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.discriminator = _data["discriminator"] !== undefined ? _data["discriminator"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUtilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IUpdateUtilityRequest {
    id?: number;
    discriminator?: UtilityTables;
    key?: string | null;
    value?: string | null;
}

export class DeleteUtilityResponse implements IDeleteUtilityResponse {

    constructor(data?: IDeleteUtilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteUtilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUtilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteUtilityResponse {
}

export class GetPersonsResponse implements IGetPersonsResponse {
    persons?: Person[] | null;

    constructor(data?: IGetPersonsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(Person.fromJS(item));
            }
            else {
                this.persons = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPersonsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonsResponse {
    persons?: Person[] | null;
}

export abstract class BaseEntityOfInteger implements IBaseEntityOfInteger {
    id?: number;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;

    constructor(data?: IBaseEntityOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
        }
    }

    static fromJS(data: any): BaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        return data;
    }
}

export interface IBaseEntityOfInteger {
    id?: number;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
}

export abstract class BaseEntity extends BaseEntityOfInteger implements IBaseEntity {

    constructor(data?: IBaseEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBaseEntity extends IBaseEntityOfInteger {
}

export class Person extends BaseEntity implements IPerson {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    projectPersons?: ProjectPerson[] | null;
    inKinds?: InKind[] | null;
    isDeleted?: boolean | null;

    constructor(data?: IPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.wustlEduId = _data["wustlEduId"] !== undefined ? _data["wustlEduId"] : <any>null;
            this.commonsID = _data["commonsID"] !== undefined ? _data["commonsID"] : <any>null;
            this.orcid = _data["orcid"] !== undefined ? _data["orcid"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.costCenterHierarchy = _data["costCenterHierarchy"] !== undefined ? _data["costCenterHierarchy"] : <any>null;
            if (Array.isArray(_data["projectPersons"])) {
                this.projectPersons = [] as any;
                for (let item of _data["projectPersons"])
                    this.projectPersons!.push(ProjectPerson.fromJS(item));
            }
            else {
                this.projectPersons = <any>null;
            }
            if (Array.isArray(_data["inKinds"])) {
                this.inKinds = [] as any;
                for (let item of _data["inKinds"])
                    this.inKinds!.push(InKind.fromJS(item));
            }
            else {
                this.inKinds = <any>null;
            }
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static override fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["wustlEduId"] = this.wustlEduId !== undefined ? this.wustlEduId : <any>null;
        data["commonsID"] = this.commonsID !== undefined ? this.commonsID : <any>null;
        data["orcid"] = this.orcid !== undefined ? this.orcid : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["costCenterHierarchy"] = this.costCenterHierarchy !== undefined ? this.costCenterHierarchy : <any>null;
        if (Array.isArray(this.projectPersons)) {
            data["projectPersons"] = [];
            for (let item of this.projectPersons)
                data["projectPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.inKinds)) {
            data["inKinds"] = [];
            for (let item of this.inKinds)
                data["inKinds"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPerson extends IBaseEntity {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    title?: string | null;
    department?: string | null;
    email?: string | null;
    employeeId?: string | null;
    wustlEduId?: string | null;
    commonsID?: string | null;
    orcid?: string | null;
    phone?: string | null;
    costCenterHierarchy?: string | null;
    projectPersons?: ProjectPerson[] | null;
    inKinds?: InKind[] | null;
    isDeleted?: boolean | null;
}

export class ProjectPerson extends BaseEntity implements IProjectPerson {
    project?: Project | null;
    projectId?: number;
    personId?: number;
    projectRole?: string | null;
    effortNotes?: string | null;
    personNotes?: string | null;
    key?: boolean;
    person?: Person | null;
    projectEfforts?: ProjectEffort[] | null;
    projectRoleDesc?: string | null;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    isDeleted?: boolean | null;

    constructor(data?: IProjectPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.projectRole = _data["projectRole"] !== undefined ? _data["projectRole"] : <any>null;
            this.effortNotes = _data["effortNotes"] !== undefined ? _data["effortNotes"] : <any>null;
            this.personNotes = _data["personNotes"] !== undefined ? _data["personNotes"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>null;
            if (Array.isArray(_data["projectEfforts"])) {
                this.projectEfforts = [] as any;
                for (let item of _data["projectEfforts"])
                    this.projectEfforts!.push(ProjectEffort.fromJS(item));
            }
            else {
                this.projectEfforts = <any>null;
            }
            this.projectRoleDesc = _data["projectRoleDesc"] !== undefined ? _data["projectRoleDesc"] : <any>null;
            this.grantNumber = _data["grantNumber"] !== undefined ? _data["grantNumber"] : <any>null;
            this.grantNumberDetail = _data["grantNumberDetail"] !== undefined ? _data["grantNumberDetail"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static override fromJS(data: any): ProjectPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["projectRole"] = this.projectRole !== undefined ? this.projectRole : <any>null;
        data["effortNotes"] = this.effortNotes !== undefined ? this.effortNotes : <any>null;
        data["personNotes"] = this.personNotes !== undefined ? this.personNotes : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        if (Array.isArray(this.projectEfforts)) {
            data["projectEfforts"] = [];
            for (let item of this.projectEfforts)
                data["projectEfforts"].push(item.toJSON());
        }
        data["projectRoleDesc"] = this.projectRoleDesc !== undefined ? this.projectRoleDesc : <any>null;
        data["grantNumber"] = this.grantNumber !== undefined ? this.grantNumber : <any>null;
        data["grantNumberDetail"] = this.grantNumberDetail !== undefined ? this.grantNumberDetail : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectPerson extends IBaseEntity {
    project?: Project | null;
    projectId?: number;
    personId?: number;
    projectRole?: string | null;
    effortNotes?: string | null;
    personNotes?: string | null;
    key?: boolean;
    person?: Person | null;
    projectEfforts?: ProjectEffort[] | null;
    projectRoleDesc?: string | null;
    grantNumber?: string | null;
    grantNumberDetail?: string | null;
    isDeleted?: boolean | null;
}

export class Project extends BaseEntity implements IProject {
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    sourceOfSupport?: string | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    overlap?: string | null;
    isSubProject?: boolean;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    projectPersons?: ProjectPerson[] | null;
    projectAssociatedCch?: ProjectAssociatedCch[] | null;
    multiplePIs?: ProjectMultiplePIs[] | null;
    subProjectMultipleLeaders?: SubProjectMultipleLeaders[] | null;
    isArchived?: boolean;
    internalNotes?: string | null;
    effortNotes?: string | null;
    projectRole?: string | null;
    personType?: string | null;
    fain?: string | null;
    awardNickname?: string | null;
    originatingSponsor?: string | null;
    directCost?: number;
    indirectCost?: number;
    isDeleted?: boolean | null;

    constructor(data?: IProject) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.subProjectTitle = _data["subProjectTitle"] !== undefined ? _data["subProjectTitle"] : <any>null;
            this.majorGoals = _data["majorGoals"] !== undefined ? _data["majorGoals"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.projectNumber = _data["projectNumber"] !== undefined ? _data["projectNumber"] : <any>null;
            this.projectNumberRMS = _data["projectNumberRMS"] !== undefined ? _data["projectNumberRMS"] : <any>null;
            this.projectNumberWD = _data["projectNumberWD"] !== undefined ? _data["projectNumberWD"] : <any>null;
            this.piLastName = _data["piLastName"] !== undefined ? _data["piLastName"] : <any>null;
            this.piFirstName = _data["piFirstName"] !== undefined ? _data["piFirstName"] : <any>null;
            this.subLeaderLastName = _data["subLeaderLastName"] !== undefined ? _data["subLeaderLastName"] : <any>null;
            this.subLeaderFirstName = _data["subLeaderFirstName"] !== undefined ? _data["subLeaderFirstName"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateProvince = _data["stateProvince"] !== undefined ? _data["stateProvince"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.isSubProject = _data["isSubProject"] !== undefined ? _data["isSubProject"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.totalAwardAmount = _data["totalAwardAmount"] !== undefined ? _data["totalAwardAmount"] : <any>null;
            if (Array.isArray(_data["projectPersons"])) {
                this.projectPersons = [] as any;
                for (let item of _data["projectPersons"])
                    this.projectPersons!.push(ProjectPerson.fromJS(item));
            }
            else {
                this.projectPersons = <any>null;
            }
            if (Array.isArray(_data["projectAssociatedCch"])) {
                this.projectAssociatedCch = [] as any;
                for (let item of _data["projectAssociatedCch"])
                    this.projectAssociatedCch!.push(ProjectAssociatedCch.fromJS(item));
            }
            else {
                this.projectAssociatedCch = <any>null;
            }
            if (Array.isArray(_data["multiplePIs"])) {
                this.multiplePIs = [] as any;
                for (let item of _data["multiplePIs"])
                    this.multiplePIs!.push(ProjectMultiplePIs.fromJS(item));
            }
            else {
                this.multiplePIs = <any>null;
            }
            if (Array.isArray(_data["subProjectMultipleLeaders"])) {
                this.subProjectMultipleLeaders = [] as any;
                for (let item of _data["subProjectMultipleLeaders"])
                    this.subProjectMultipleLeaders!.push(SubProjectMultipleLeaders.fromJS(item));
            }
            else {
                this.subProjectMultipleLeaders = <any>null;
            }
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.effortNotes = _data["effortNotes"] !== undefined ? _data["effortNotes"] : <any>null;
            this.projectRole = _data["projectRole"] !== undefined ? _data["projectRole"] : <any>null;
            this.personType = _data["personType"] !== undefined ? _data["personType"] : <any>null;
            this.fain = _data["fain"] !== undefined ? _data["fain"] : <any>null;
            this.awardNickname = _data["awardNickname"] !== undefined ? _data["awardNickname"] : <any>null;
            this.originatingSponsor = _data["originatingSponsor"] !== undefined ? _data["originatingSponsor"] : <any>null;
            this.directCost = _data["directCost"] !== undefined ? _data["directCost"] : <any>null;
            this.indirectCost = _data["indirectCost"] !== undefined ? _data["indirectCost"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static override fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["subProjectTitle"] = this.subProjectTitle !== undefined ? this.subProjectTitle : <any>null;
        data["majorGoals"] = this.majorGoals !== undefined ? this.majorGoals : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["projectNumber"] = this.projectNumber !== undefined ? this.projectNumber : <any>null;
        data["projectNumberRMS"] = this.projectNumberRMS !== undefined ? this.projectNumberRMS : <any>null;
        data["projectNumberWD"] = this.projectNumberWD !== undefined ? this.projectNumberWD : <any>null;
        data["piLastName"] = this.piLastName !== undefined ? this.piLastName : <any>null;
        data["piFirstName"] = this.piFirstName !== undefined ? this.piFirstName : <any>null;
        data["subLeaderLastName"] = this.subLeaderLastName !== undefined ? this.subLeaderLastName : <any>null;
        data["subLeaderFirstName"] = this.subLeaderFirstName !== undefined ? this.subLeaderFirstName : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateProvince"] = this.stateProvince !== undefined ? this.stateProvince : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["isSubProject"] = this.isSubProject !== undefined ? this.isSubProject : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["totalAwardAmount"] = this.totalAwardAmount !== undefined ? this.totalAwardAmount : <any>null;
        if (Array.isArray(this.projectPersons)) {
            data["projectPersons"] = [];
            for (let item of this.projectPersons)
                data["projectPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.projectAssociatedCch)) {
            data["projectAssociatedCch"] = [];
            for (let item of this.projectAssociatedCch)
                data["projectAssociatedCch"].push(item.toJSON());
        }
        if (Array.isArray(this.multiplePIs)) {
            data["multiplePIs"] = [];
            for (let item of this.multiplePIs)
                data["multiplePIs"].push(item.toJSON());
        }
        if (Array.isArray(this.subProjectMultipleLeaders)) {
            data["subProjectMultipleLeaders"] = [];
            for (let item of this.subProjectMultipleLeaders)
                data["subProjectMultipleLeaders"].push(item.toJSON());
        }
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["effortNotes"] = this.effortNotes !== undefined ? this.effortNotes : <any>null;
        data["projectRole"] = this.projectRole !== undefined ? this.projectRole : <any>null;
        data["personType"] = this.personType !== undefined ? this.personType : <any>null;
        data["fain"] = this.fain !== undefined ? this.fain : <any>null;
        data["awardNickname"] = this.awardNickname !== undefined ? this.awardNickname : <any>null;
        data["originatingSponsor"] = this.originatingSponsor !== undefined ? this.originatingSponsor : <any>null;
        data["directCost"] = this.directCost !== undefined ? this.directCost : <any>null;
        data["indirectCost"] = this.indirectCost !== undefined ? this.indirectCost : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IBaseEntity {
    title?: string | null;
    subProjectTitle?: string | null;
    majorGoals?: string | null;
    status?: string | null;
    projectNumber?: string | null;
    projectNumberRMS?: string | null;
    projectNumberWD?: string | null;
    piLastName?: string | null;
    piFirstName?: string | null;
    subLeaderLastName?: string | null;
    subLeaderFirstName?: string | null;
    sourceOfSupport?: string | null;
    placeOfPerformance?: string | null;
    city?: string | null;
    stateProvince?: string | null;
    country?: string | null;
    overlap?: string | null;
    isSubProject?: boolean;
    startDate?: Date | null;
    endDate?: Date | null;
    totalAwardAmount?: number;
    projectPersons?: ProjectPerson[] | null;
    projectAssociatedCch?: ProjectAssociatedCch[] | null;
    multiplePIs?: ProjectMultiplePIs[] | null;
    subProjectMultipleLeaders?: SubProjectMultipleLeaders[] | null;
    isArchived?: boolean;
    internalNotes?: string | null;
    effortNotes?: string | null;
    projectRole?: string | null;
    personType?: string | null;
    fain?: string | null;
    awardNickname?: string | null;
    originatingSponsor?: string | null;
    directCost?: number;
    indirectCost?: number;
    isDeleted?: boolean | null;
}

export class ProjectAssociatedCch extends BaseEntity implements IProjectAssociatedCch {
    projectId?: number;
    costCenterHierarchy?: string | null;

    constructor(data?: IProjectAssociatedCch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.costCenterHierarchy = _data["costCenterHierarchy"] !== undefined ? _data["costCenterHierarchy"] : <any>null;
        }
    }

    static override fromJS(data: any): ProjectAssociatedCch {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAssociatedCch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["costCenterHierarchy"] = this.costCenterHierarchy !== undefined ? this.costCenterHierarchy : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectAssociatedCch extends IBaseEntity {
    projectId?: number;
    costCenterHierarchy?: string | null;
}

export class ProjectMultiplePIs extends BaseEntity implements IProjectMultiplePIs {
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;

    constructor(data?: IProjectMultiplePIs) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
        }
    }

    static override fromJS(data: any): ProjectMultiplePIs {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMultiplePIs();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectMultiplePIs extends IBaseEntity {
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;
}

export class SubProjectMultipleLeaders extends BaseEntity implements ISubProjectMultipleLeaders {
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;

    constructor(data?: ISubProjectMultipleLeaders) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
        }
    }

    static override fromJS(data: any): SubProjectMultipleLeaders {
        data = typeof data === 'object' ? data : {};
        let result = new SubProjectMultipleLeaders();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISubProjectMultipleLeaders extends IBaseEntity {
    firstName?: string | null;
    lastName?: string | null;
    projectId?: number;
}

export class ProjectEffort extends BaseEntity implements IProjectEffort {
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;
    projectPersonId?: number;
    projectPerson?: ProjectPerson | null;

    constructor(data?: IProjectEffort) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
            this.projectPersonId = _data["projectPersonId"] !== undefined ? _data["projectPersonId"] : <any>null;
            this.projectPerson = _data["projectPerson"] ? ProjectPerson.fromJS(_data["projectPerson"]) : <any>null;
        }
    }

    static override fromJS(data: any): ProjectEffort {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEffort();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        data["projectPersonId"] = this.projectPersonId !== undefined ? this.projectPersonId : <any>null;
        data["projectPerson"] = this.projectPerson ? this.projectPerson.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectEffort extends IBaseEntity {
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;
    projectPersonId?: number;
    projectPerson?: ProjectPerson | null;
}

export class InKind extends BaseEntity implements IInKind {
    personId?: number;
    person?: Person | null;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffort[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    sourceOfSupport?: string | null;
    overlap?: string | null;
    isDeleted?: boolean | null;

    constructor(data?: IInKind) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.placeOfPerformance = _data["placeOfPerformance"] !== undefined ? _data["placeOfPerformance"] : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            if (Array.isArray(_data["inKindEfforts"])) {
                this.inKindEfforts = [] as any;
                for (let item of _data["inKindEfforts"])
                    this.inKindEfforts!.push(InKindEffort.fromJS(item));
            }
            else {
                this.inKindEfforts = <any>null;
            }
            this.estimatedDollarValue = _data["estimatedDollarValue"] !== undefined ? _data["estimatedDollarValue"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
            this.osrNotes = _data["osrNotes"] !== undefined ? _data["osrNotes"] : <any>null;
            this.internalNotes = _data["internalNotes"] !== undefined ? _data["internalNotes"] : <any>null;
            this.overallObjectives = _data["overallObjectives"] !== undefined ? _data["overallObjectives"] : <any>null;
            this.sourceOfSupport = _data["sourceOfSupport"] !== undefined ? _data["sourceOfSupport"] : <any>null;
            this.overlap = _data["overlap"] !== undefined ? _data["overlap"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static override fromJS(data: any): InKind {
        data = typeof data === 'object' ? data : {};
        let result = new InKind();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["placeOfPerformance"] = this.placeOfPerformance !== undefined ? this.placeOfPerformance : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        if (Array.isArray(this.inKindEfforts)) {
            data["inKindEfforts"] = [];
            for (let item of this.inKindEfforts)
                data["inKindEfforts"].push(item.toJSON());
        }
        data["estimatedDollarValue"] = this.estimatedDollarValue !== undefined ? this.estimatedDollarValue : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        data["osrNotes"] = this.osrNotes !== undefined ? this.osrNotes : <any>null;
        data["internalNotes"] = this.internalNotes !== undefined ? this.internalNotes : <any>null;
        data["overallObjectives"] = this.overallObjectives !== undefined ? this.overallObjectives : <any>null;
        data["sourceOfSupport"] = this.sourceOfSupport !== undefined ? this.sourceOfSupport : <any>null;
        data["overlap"] = this.overlap !== undefined ? this.overlap : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInKind extends IBaseEntity {
    personId?: number;
    person?: Person | null;
    summary?: string | null;
    status?: string | null;
    placeOfPerformance?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    inKindEfforts?: InKindEffort[] | null;
    estimatedDollarValue?: number;
    isArchived?: boolean | null;
    osrNotes?: string | null;
    internalNotes?: string | null;
    overallObjectives?: string | null;
    sourceOfSupport?: string | null;
    overlap?: string | null;
    isDeleted?: boolean | null;
}

export class InKindEffort extends BaseEntity implements IInKindEffort {
    inKindId?: number;
    inKind?: InKind | null;
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;

    constructor(data?: IInKindEffort) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inKindId = _data["inKindId"] !== undefined ? _data["inKindId"] : <any>null;
            this.inKind = _data["inKind"] ? InKind.fromJS(_data["inKind"]) : <any>null;
            this.yearSequence = _data["yearSequence"] !== undefined ? _data["yearSequence"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.months = _data["months"] !== undefined ? _data["months"] : <any>null;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : <any>null;
        }
    }

    static override fromJS(data: any): InKindEffort {
        data = typeof data === 'object' ? data : {};
        let result = new InKindEffort();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inKindId"] = this.inKindId !== undefined ? this.inKindId : <any>null;
        data["inKind"] = this.inKind ? this.inKind.toJSON() : <any>null;
        data["yearSequence"] = this.yearSequence !== undefined ? this.yearSequence : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["months"] = this.months !== undefined ? this.months : <any>null;
        data["percent"] = this.percent !== undefined ? this.percent : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInKindEffort extends IBaseEntity {
    inKindId?: number;
    inKind?: InKind | null;
    yearSequence?: string | null;
    year?: number;
    months?: number;
    percent?: number;
}

export class GetPersonResponse implements IGetPersonResponse {
    person?: Person | null;

    constructor(data?: IGetPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPersonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>null;
        return data;
    }
}

export interface IGetPersonResponse {
    person?: Person | null;
}

export class GetResearchersListResponse implements IGetResearchersListResponse {
    persons?: Person[];
    recordCount?: number;

    constructor(data?: IGetResearchersListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(Person.fromJS(item));
            }
            else {
                this.persons = <any>null;
            }
            this.recordCount = _data["recordCount"] !== undefined ? _data["recordCount"] : <any>null;
        }
    }

    static fromJS(data: any): GetResearchersListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResearchersListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item.toJSON());
        }
        data["recordCount"] = this.recordCount !== undefined ? this.recordCount : <any>null;
        return data;
    }
}

export interface IGetResearchersListResponse {
    persons?: Person[];
    recordCount?: number;
}

export class UpdateReportPersonNameRequest implements IUpdateReportPersonNameRequest {
    id?: number;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;

    constructor(data?: IUpdateReportPersonNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportPersonNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportPersonNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }
}

export interface IUpdateReportPersonNameRequest {
    id?: number;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
}

export class UpdateReportPersonCommonsId implements IUpdateReportPersonCommonsId {
    id?: number;
    commonsId?: string | null;

    constructor(data?: IUpdateReportPersonCommonsId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.commonsId = _data["commonsId"] !== undefined ? _data["commonsId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateReportPersonCommonsId {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportPersonCommonsId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["commonsId"] = this.commonsId !== undefined ? this.commonsId : <any>null;
        return data;
    }
}

export interface IUpdateReportPersonCommonsId {
    id?: number;
    commonsId?: string | null;
}

export class GetProjectPersonEffortsResponse implements IGetProjectPersonEffortsResponse {
    projectEfforts?: ProjectEffortVM[] | null;

    constructor(data?: IGetProjectPersonEffortsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectEfforts"])) {
                this.projectEfforts = [] as any;
                for (let item of _data["projectEfforts"])
                    this.projectEfforts!.push(ProjectEffortVM.fromJS(item));
            }
            else {
                this.projectEfforts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetProjectPersonEffortsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectPersonEffortsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectEfforts)) {
            data["projectEfforts"] = [];
            for (let item of this.projectEfforts)
                data["projectEfforts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectPersonEffortsResponse {
    projectEfforts?: ProjectEffortVM[] | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}